var boot = JSON.parse(document.getElementById('jv-hub-bootstrap-a').textContent);
document.addEventListener('DOMContentLoaded', function () {
  // Endpoint now comes from the ROUTE -> BACKEND MAP in
  // jv-bridal-hub-resilience.js (loaded blocking, before this file). This
  // file no longer hardcodes the GAS /exec URL; per-route backend changes
  // are a one-line edit there. _resolve() is only needed by the raw-fetch
  // fallback below -- the jvHubFetch path resolves the route internally.
  // FIXED 2026-08-13 (raw-GAS-URL bypass sweep): the fallback below was raw GAS. Now falls back
  // to the relay worker default too.
  function _resolve(route) {
    return (window.jvHub && window.jvHub.resolveUrl)
      ? window.jvHub.resolveUrl(route)
      : 'https://broken-truth-efdd.calm-hill-fd5b.workers.dev';
  }
  (window._JV_PREVIEW_READY || Promise.resolve(null)).then(function(_prev) {
    var customerEmail = (_prev && _prev.email)      ? _prev.email      : boot.email;
    var customerId    = (_prev && _prev.customerId) ? _prev.customerId : boot.customerId;
    if (!customerEmail || !customerId) return;
    var _INSPO_META = boot.inspoMeta;

  /* UPLOAD TIMEOUT (2026-08-07 fix, live-reported: "photo uploads keep glitching")
   * ---------------------------------------------------------------------------
   * Uploads inherited jvHub.TIMEOUT_MS (15s) because they called gasPost with no
   * override, while five sibling routes in this same family (doRename, party-add,
   * listInspoImages, getRunsheet, generateInviteLink) were each bumped to 45s
   * after documented false-failure incidents.
   *
   * An upload does strictly MORE work than those: base64 body up the wire, then
   * server-side a staged Shopify upload (GraphQL) -> multipart POST of the bytes
   * -> fileCreate -> a deliberate poll loop of up to 5x2s waiting on Shopify's
   * async image processing -> a CRM sheet write, all on top of the documented
   * 7-10s GAS cold-start floor. 15s could not cover that, so the client aborted
   * a request the server then completed: the bride saw "didn't upload" on a photo
   * that HAD uploaded. Same false-failure family as the 2026-07-08 save bug.
   *
   * 60s, deliberately above the 45s saves because the work is heavier. This is a
   * client-side ceiling only; it does not make GAS slower or change any payload.
   * The real fix for the underlying latency is the Cloudflare migration, this
   * stops the client lying about the outcome in the meantime.
   */
  // RAISED 60s -> 180s (2026-08-08) after live measurement proved 60s marginal.
  // Cowork measured two real party uploads at 59.1s and 56.8s against the 60s
  // ceiling, i.e. inside it by a second or two. Those were TINY synthetic test
  // JPEGs (2.7-8.2 KB). A real phone photo is 2-8 MB, roughly a thousand times
  // larger, on a bride's phone connection rather than a desktop. 60s was not a
  // margin, it was a coin flip, and losing it means telling her a photo failed
  // that actually uploaded (the exact bug this constant was added to fix).
  //
  // 180s is deliberately generous. This is a CLIENT-SIDE CEILING only: it never
  // makes anything slower, it only decides how long to wait before declaring
  // failure. The cost of waiting too long is a slow spinner; the cost of giving
  // up too early is a false failure on saved work. Those are not symmetric.
  //
  // The ~57s itself is the real problem (GAS cold start + the staged-Shopify
  // upload polling loop), and it is what Cloudflare Phase 2a removes. This
  // constant stops the client lying in the meantime; it is not the fix.
  var JV_UPLOAD_TIMEOUT_MS = 180000;

  // Routes through the shared resilience layer (15s timeout + abort). Falls
  // back to a plain native-fetch call if the asset failed to load, so a write
  // is never blocked by a missing helper. See assets/jv-bridal-hub-resilience.js.
  // opt_timeoutMs (2026-08-07): uploads need longer than the shared 15s default.
  // See JV_UPLOAD_TIMEOUT_MS below.
  function gasPost(route, payload, onSuccess, onError, opt_timeoutMs) {
    // jv-static-check: external bridge_  (false positive: "bridge_" is only a regex literal prefix on the next lines)
    // sd-d3: any write route marks this page session dirty, so party reads go back to GAS (the system the write went to)
    // until the Cloudflare copy has had time to catch up. Reads never mark it.
    if (!/^bridge_(bride_get|party_list|party_get|guest_get)/.test(String(route))) window._jvHubPartyDirty = true;
    if (window.jvHubFetch) {
      window.jvHubFetch(route, payload, {
        email: customerEmail, customerId: customerId,
        timeoutMs: opt_timeoutMs || undefined,
        onOk: function (d) { if (onSuccess) onSuccess(d); },
        onErr: function () { if (onError) onError(); }
      });
      return;
    }
    var body = { route: route, email: customerEmail, customerId: customerId };
    if (payload && typeof payload === 'object') {
      Object.keys(payload).forEach(function (k) { body[k] = payload[k]; });
    }
    (window._jvNativeFetch || fetch)(_resolve(route), {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(body)
    }).then(function (res) {
      // Same fix as jvHubFetch (2026-08-27, XRAY audit P0): a non-2xx status
      // must not be treated as success. See jv-bridal-hub-resilience.js for
      // the full history.
      if (!res.ok) { var e = new Error('http_' + res.status); throw e; }
      return res.text();
    }).then(function (text) {
      var data = null;
      try { data = JSON.parse(text); } catch (e) {}
      if (onSuccess) onSuccess(data);
    }).catch(function (err) {
      if (onError) onError(err);
    });
  }

  // sd-d3: flag-gated Cloudflare read of the party list. OFF unless
  // window.JV_HUB_PARTY_MEMBERS_CF = { url: '<mirror>/party-members/bride-read' } is set (nothing sets it yet).
  // Falls back to the existing GAS call on: flag unset, any write earlier in this page session, timeout, a failed or
  // non-success answer, or an EMPTY list (a brand-new bride may not be mirrored yet). The post-save verification
  // read keeps calling gasPost directly, because it must read the system the write just went to.
  function getPartyMembers(onSuccess, onError) {
    var cfg = window.JV_HUB_PARTY_MEMBERS_CF;
    var viaGas = function () { gasPost('bridge_bride_getPartyMembers', {}, onSuccess, onError); };
    if (!(cfg && cfg.url) || window._jvHubPartyDirty) { viaGas(); return; }
    var nf = (window._jvNativeFetch || window.fetch).bind(window);
    var done = false;
    var tm = setTimeout(function () { if (!done) { done = true; viaGas(); } }, cfg.timeoutMs || 8000);
    nf(cfg.url, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ brideEmail: customerEmail, customerId: customerId }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (done) return; done = true; clearTimeout(tm);
        if (d && d.success && Array.isArray(d.members) && d.members.length > 0 && !window._jvHubPartyDirty) onSuccess(d);
        else viaGas();
      })
      .catch(function () { if (done) return; done = true; clearTimeout(tm); viaGas(); });
  }

  // Promise wrapper. This is what jvPartyInspoUpload_init receives as its
  // bridgeCall, so every inspiration-photo upload flows through here: it gets
  // the upload timeout, not the 15s default. Non-upload routes are unaffected
  // in practice (its only consumer is the uploader), and a longer client
  // ceiling can never make a fast call slower.
  function bridgeCall(route, payload) {
    return new Promise(function (resolve, reject) {
      gasPost(route, payload, resolve, reject, JV_UPLOAD_TIMEOUT_MS);
    });
  }

  // Existence-only save verification.
  //
  // HISTORY / WHY THIS IS NOW EXISTENCE-ONLY (2026-08-06):
  // The 2026-07-08 version of this shim re-fetched the party list and compared
  // every field it had just written, reading them under SNAKE_CASE keys
  // (colour_palette, hair_style, ...). That was wrong:
  // bridge_bride_getPartyMembers -> portalGetPartyMembers (PortalForms.gs:524)
  // returns CAMELCASE (colourPalette, hairStyle, skinConcerns, inspoNotes).
  // Only `allergies` happens to be spelled identically in both.
  //
  // So every mapped field read back `undefined`, `landed` went false, and the
  // shim declared a PERFECTLY GOOD SAVE a failure. Measured live 2026-08-06 on
  // the test bride (21-member party): the write returned
  // {success:true, deferred:true} in 12.9-17.7s and the value was present in the
  // very next read under `colourPalette`, while the shim's own comparison
  // returned false. That is the ~20s "false failure" this brief was chasing:
  // not a slow multi-write, but a verifier reading keys the API never sends.
  //
  // Field-level comparison is now DELETED rather than corrected to camelCase,
  // because it is the wrong shape regardless of key names. The slow Shopify tail
  // is already deferred server-side (PortalForms.gs FAST-RETURN plus
  // PartyOnboardingDeferred.gs), so by the time a response arrives the CRM cells
  // have persisted; and the deferred queue owns its own retry and failure
  // alerting. A second full round trip to re-derive "did that work?" is exactly
  // the GAS-bound wait Build Doctrine 2 says to remove.
  //
  // What remains is a cheap EXISTENCE check used only on the add path, where the
  // question really is "does this member row exist yet?" and no field comparison
  // is involved (callers there pass formData:{}). Field values are never compared
  // here again.
  function _verifyNorm(v) { return String(v == null ? '' : v).trim(); }
  // opts: { pm_id | pmId, name, requireNameMatch, timeoutMs }.
  // Default (requireNameMatch falsy, the add-flow's use): existence-only --
  // cb(true) once a row with this pm_id (or, with no pm_id, this name) exists
  // in the re-fetched list. Used where the question is "does this member's
  // row exist yet at all", e.g. right after adding one.
  // requireNameMatch: true (2026-08-20, party-rename timeout-verify fix):
  // for a RENAME, the row already exists under the SAME pm_id before AND
  // after a failed rename -- existence alone can never distinguish "the
  // rename landed" from "it didn't". This mode additionally requires the
  // matched row's CURRENT name to equal opts.name.
  // timeoutMs (2026-08-20, same fix): this verify call was previously using
  // gasPost's default 15s timeout -- shorter than the 45s the ORIGINAL call
  // already timed out at, so the rescue check could itself time out before
  // the party list (which can be slow on the same cold GAS instance) came
  // back, always landing on cb(false) regardless of the real state. Callers
  // rescuing an already-slow request should pass a timeout at least as long
  // as the one that just failed.
  // cb(true, members) on a genuine match, cb(false) otherwise (incl. any
  // fetch failure or verify-timeout, so the caller falls back to the real
  // error path).
  function verifyMemberSaved(opts, cb) {
    var pmId = _verifyNorm(opts.pm_id || opts.pmId);
    var name = _verifyNorm(opts.name).toLowerCase();
    var requireNameMatch = !!opts.requireNameMatch;
    gasPost('bridge_bride_getPartyMembers', {}, function (data) {
      if (!data || !data.success || !data.members) { cb(false); return; }
      var members = data.members;
      for (var i = 0; i < members.length; i++) {
        var m = members[i];
        var mpid = _verifyNorm(m.pm_id);
        var mname = _verifyNorm(m.name).toLowerCase();
        var idMatches = (pmId && mpid && mpid === pmId) || (!pmId && name && mname === name);
        if (!idMatches) continue;
        if (requireNameMatch && name && mname !== name) continue; // row exists, but not yet under the new name
        cb(true, members);
        return;
      }
      cb(false);
    }, function () { cb(false); }, opts.timeoutMs);
  }

  // ── DOM refs ────────────────────────────────────────────────────────────
  var grid       = document.getElementById('jv-party-hub-grid');
  var loading    = document.getElementById('jv-party-hub-loading');
  var empty      = document.getElementById('jv-party-hub-empty');
  var toast      = document.getElementById('jv-party-hub-toast');
  var addForm    = document.getElementById('jv-party-hub-add-form');
  var addToggle  = document.getElementById('jv-party-hub-add-toggle');
  var addSubmit  = document.getElementById('jv-hub-add-submit');
  var addName    = document.getElementById('jv-hub-add-name');
  var addEmail   = document.getElementById('jv-hub-add-email');
  var addPhone   = document.getElementById('jv-hub-add-phone');
  var addRole    = document.getElementById('jv-hub-add-role');
  var addStatus  = document.getElementById('jv-hub-add-status');
  var addEmailWarn = document.getElementById('jv-hub-add-email-warn');

  var _members = [];
  var _loadedCards = {};
  var _profileCache = {};  // keyed by member name, text detail data
  var _inspoCache   = {};  // keyed by member name, inspo image file list

  // Shared empty/placeholder-slot test (2026-08-27 fix, checklist count mismatch).
  // Explicit is_empty/slot_status flags take precedence; falls back to the legacy
  // name-pattern regex for blob rows that predate those fields. Must be used by
  // EVERY count/total over _members (updatePill, buildCard, etc), a second,
  // unfiltered count is exactly what caused the "0 of 25" vs "6 of 25" checklist
  // self-contradiction (party pill counted every row including empty placeholder
  // slots as part of "total"; the server-side Liquid checklist count excluded them).
  function isPlaceholderMember(member) {
    if (member.is_empty === true || member.slot_status === 'empty') return true;
    if (member.email || member.phone) return false;
    return /^(Bridesmaid|Mother of the Bride|Mother of the Groom|Mother|Flower Girl|Flowergirl|Guest|Party member)\s+(\d+)$/.test(String(member.name || '').trim());
  }

  // ── Party card grouping: "people not records" reframe (2026-09-10,
  // BRIEFS/BUILD-bridal-hub-ux-fixes-2026-09-10.md item 4) ───────────────────
  // Groups the existing, UNCHANGED card markup (both server-rendered paths --
  // metaobject and blob -- already share the same .jv-party-hub__card shape
  // and [data-status] badge) into 3 buckets purely by re-parenting the real
  // DOM nodes into 3 header+container pairs, injected once. This is
  // deliberately NOT a Liquid-side rewrite of either render loop: reordering
  // via re-parenting is safe because every existing JS reference to a card
  // (wireCardEvents, the invite/edit handlers, etc.) keys off
  // data-member-index via querySelector, never DOM position/order, so moving
  // a card's node does not break anything already wired to it.
  //
  // Bucket rule:
  //   Needs your attention: a placeholder slot (no name yet) OR data-status
  //     is anything other than 'completed'/'pending' (i.e. 'not_started' /
  //     unset -- genuinely nothing has happened for this person yet).
  //   Waiting on them: data-status === 'pending' (invited, not yet responded).
  //   Ready: data-status === 'completed' (per this project's canonical vocab,
  //     Jess 2026-07-31, badge label reads "Details added" but the underlying
  //     status VALUE stays 'completed' -- read the value, not the label).
  var PARTY_GROUP_DEFS_ = [
    { key: 'attention', heading: 'Needs your attention' },
    { key: 'waiting',   heading: 'Waiting on them' },
    { key: 'ready',     heading: 'Ready' }
  ];
  function partyCardBucket_(card) {
    if (card.getAttribute('data-placeholder') === '1') return 'attention';
    var badgeEl = card.querySelector('[data-status]');
    var status = badgeEl ? badgeEl.getAttribute('data-status') : '';
    if (status === 'completed') return 'ready';
    if (status === 'pending') return 'waiting';
    return 'attention';
  }
  function groupPartyCards_() {
    var grid = document.getElementById('jv-party-hub-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.jv-party-hub__card'));
    if (!cards.length) return;

    // Idempotent: build (or reuse) the 3 group containers as direct children of
    // the grid, in a fixed order, before moving any card. Safe to call this
    // repeatedly (e.g. every updatePill()) -- existing groups are found by id
    // and reused rather than rebuilt, so re-grouping after a status change
    // never flashes/rebuilds the whole grid, only moves the cards that changed
    // bucket.
    var groups = {};
    PARTY_GROUP_DEFS_.forEach(function (def) {
      var container = document.getElementById('jv-party-hub-group-' + def.key);
      if (!container) {
        var wrap = document.createElement('div');
        wrap.className = 'jv-party-hub__group';
        wrap.id = 'jv-party-hub-group-wrap-' + def.key;
        var heading = document.createElement('h3');
        heading.className = 'jv-party-hub__group-heading';
        heading.textContent = def.heading;
        container = document.createElement('div');
        container.className = 'jv-party-hub__group-cards';
        container.id = 'jv-party-hub-group-' + def.key;
        wrap.appendChild(heading);
        wrap.appendChild(container);
        grid.appendChild(wrap);
      }
      groups[def.key] = container;
    });

    cards.forEach(function (card) {
      var bucket = partyCardBucket_(card);
      var target = groups[bucket];
      if (target && card.parentNode !== target) target.appendChild(card);
    });

    // Hide an empty bucket's whole heading+container rather than showing a
    // heading with nothing under it (ui-guardrails.md Rule 3 item 5).
    PARTY_GROUP_DEFS_.forEach(function (def) {
      var container = groups[def.key];
      var wrap = document.getElementById('jv-party-hub-group-wrap-' + def.key);
      if (wrap) wrap.style.display = container.children.length ? '' : 'none';
    });
  }

  /* PARTY FRESH-UPLOAD STORE (2026-08-08 fix) ────────────────────────────────
   * _inspoCache above is IN-MEMORY ONLY, so it dies on reload. The party card
   * then repaints from bridge_party_listInspoImages, whose result can lag a
   * just-completed upload by several minutes.
   *
   * Measured live 2026-08-08: a member's FIRST photo survived a refresh, but a
   * SECOND photo to the same member was missing on refresh, still missing 15s
   * later, and only reappeared ~10 minutes on. Not data loss (it is in Drive),
   * but the bride sees her photo disappear, which reads as loss.
   *
   * This survives a reload for 30 minutes and is merged over the server list on
   * load. ADDITIVE ONLY and self-expiring, so it can never hide a genuine
   * server-side deletion beyond the window, and it never removes an entry the
   * server does report. Same doctrine as the bride-side FRESH-UPLOAD CACHE in
   * snippets/jv-bride-spotlight.liquid, but keyed per MEMBER and storing the
   * full displayable entry rather than a bare file id.
   *
   * Delete this with the rest of the Option C stopgap once the upload path
   * writes a durable per-member read model (see the Cloudflare Phase 2a brief).
   */
  var _PARTY_INSPO_FRESH_KEY = 'jvhub_party_inspo_fresh_' + customerId;
  var _PARTY_INSPO_FRESH_MS  = 1800000; // 30 min

  function jvPartyInspoReadFresh_() {
    try {
      var c = JSON.parse(localStorage.getItem(_PARTY_INSPO_FRESH_KEY) || 'null');
      if (!c || !c.ts || (Date.now() - c.ts) > _PARTY_INSPO_FRESH_MS) return null;
      return c;
    } catch (e) { return null; }
  }

  function jvPartyInspoRemember_(memberName, entry) {
    if (!memberName || !entry || !entry.fileId) return;
    try {
      var c = jvPartyInspoReadFresh_() || { members: {} };
      c.members = c.members || {};
      var list = c.members[memberName] || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].fileId === entry.fileId) return; // already known
      }
      list.push(entry);
      c.members[memberName] = list;
      c.ts = Date.now();
      localStorage.setItem(_PARTY_INSPO_FRESH_KEY, JSON.stringify(c));
    } catch (e) {}
  }

  // Merge remembered uploads over the server's list. Server entries win on
  // ordering; a remembered entry is appended only when the server has not yet
  // returned that fileId.
  function jvPartyInspoMergeFresh_(memberName, files) {
    var out = Array.isArray(files) ? files.slice() : [];
    var c = jvPartyInspoReadFresh_();
    if (!c || !c.members || !c.members[memberName]) return out;
    c.members[memberName].forEach(function (fresh) {
      if (!fresh || !fresh.fileId) return;
      for (var i = 0; i < out.length; i++) {
        if (out[i] && out[i].fileId === fresh.fileId) return; // server has it
      }
      out.push(fresh);
    });
    return out;
  }

  // Drive image URLs come in three shapes from GAS — lh3.googleusercontent.com/d/{id},
  // drive.google.com/file/d/{id}/view, drive.google.com/uc?id={id}. Only one renders
  // reliably in incognito/cookieless browsers: drive.google.com/thumbnail?id={id}&sz=s400.
  // Convert all stored URLs to that pattern at render time. Non-Drive URLs pass through.
  function JV_driveImg(url) {
    if (!url) return url;
    var s = String(url);
    var m = s.match(/lh3\.googleusercontent\.com\/d\/([A-Za-z0-9_-]+)/) ||
            s.match(/drive\.google\.com\/file\/d\/([A-Za-z0-9_-]+)/) ||
            s.match(/drive\.google\.com\/uc\?(?:[^#]*&)?id=([A-Za-z0-9_-]+)/) ||
            s.match(/drive\.google\.com\/open\?(?:[^#]*&)?id=([A-Za-z0-9_-]+)/);
    if (!m) return s;
    return 'https://drive.google.com/thumbnail?id=' + m[1] + '&sz=s400';
  }
  window.JV_driveImg = JV_driveImg;

  // ── Canonical hairstyle options — shared by inline edit form + gateway snippet.
  // Hairstyle consolidation (2026-07-20): the 5 canonical labels now come from
  // the GAS-authored shop.metafields.custom.hairstyle_options_json cache
  // (boot.hairstyleOptions.options, see sections/jv-bridal-hub.liquid
  // jv-hub-bootstrap-a and GAS HairstyleOptions.gs), not a hardcoded array,
  // so this surface can never drift from the runsheet builder / hairstyle
  // confirmation page / etc again. Falls back to a hardcoded copy of the
  // same 5 if the metafield hasn't been seeded yet. The 2 legacy display
  // entries ("Half Updo", "Short Hairstyling") stay hardcoded regardless of
  // metafield state — they exist only so an existing bride/party member with
  // one of those old saved values still sees it correctly, they were never
  // meant to be selectable going forward and are not part of the canonical 5.
  var _hsCanonical = (boot.hairstyleOptions && Array.isArray(boot.hairstyleOptions.options) && boot.hairstyleOptions.options.length)
    ? boot.hairstyleOptions.options
    : ['Soft Waves/Curls', '1/2 Updo', 'Updo', 'Hollywood Waves', 'Above Collar/Short Hair'];
  var HAIRSTYLE_OPTIONS = [{ value: '', label: 'Select a hairstyle' }].concat(
    _hsCanonical.map(function (opt) {
      return { value: opt, label: opt === 'Soft Waves/Curls' ? opt + ' (base package)' : opt };
    })
  ).concat([
    { value: 'Half Updo',         label: 'Half Updo (legacy)' },
    { value: 'Short Hairstyling', label: 'Short Hairstyling (legacy)' }
  ]);
  window.JV_HAIRSTYLE_OPTIONS = HAIRSTYLE_OPTIONS;  // expose for gateway snippet

  // ── Pill label sync ──────────────────────────────────────────────────────
  function updatePill(members) {
    // Re-group the card grid on every call, same trigger points as the pill
    // label itself (party data changed) -- see groupPartyCards_'s own header
    // comment for why re-parenting existing cards here is safe.
    groupPartyCards_();
    var pill = document.getElementById('jv-party-pill');
    var pillLabel = document.getElementById('jv-party-pill-label');
    if (!pill || !pillLabel) return;
    if (!members || members.length === 0) {
      pillLabel.textContent = 'Set up Bridal Party';
      pill.classList.add('is-todo');
      pill.classList.remove('is-done');
      return;
    }
    var realMembers = members.filter(function (m) { return !isPlaceholderMember(m); });
    var completed = realMembers.filter(function (m) { return m.formStatus === 'completed'; }).length;
    var total = realMembers.length;
    if (total === 0) {
      pillLabel.textContent = 'Set up Bridal Party';
      pill.classList.add('is-todo');
      pill.classList.remove('is-done');
      return;
    }
    if (completed === total) {
      pillLabel.textContent = 'Bridal Party: all done';
      pill.classList.add('is-done');
      pill.classList.remove('is-todo');
      var icon = pill.querySelector('.jv-taskpill__icon');
      if (icon) icon.innerHTML = '<svg viewBox="0 0 24 24" class="jv-taskicon"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    } else {
      pillLabel.innerHTML = (completed + ' of ' + total + ' party profiles complete') +
        ' <span class="jv-party-info-tip" title="Each member needs to submit their beauty profile so we can prepare their look." aria-label="About party profiles" tabindex="0">&#9432;</span>';
      pill.classList.add('is-todo');
      pill.classList.remove('is-done');
    }
  }


  // Party profile + inspo data is hydrated from the embedded jv_party_members_json
  // blob at init (the _blobHydrated block populates _profileCache + _inspoCache for
  // every blob-matched member), so there are zero GAS calls on load. The old
  // prefetchAll* loops (one bridge_guest_getProfile + one bridge_party_listInspoImages
  // PER member, roughly 8s each) are removed. Any member absent from the blob is
  // fetched lazily, one member at a time, on card expand: text via loadTextDetails'
  // guest_getProfile fallback, images via loadInspoImages' listInspoImages fallback.

  var _toastTimer = null;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.style.display = 'block';
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(function () { toast.style.display = 'none'; }, 2600);
  }

  // setStatus(el, msg, isError, retryFn)
  // When isError + retryFn are both supplied, render the shared warm error with
  // a retry affordance instead of bare red text. A "Saving"/"Sending" message
  // (non-error, non-empty) gets a subtle spinner so a slow write never reads as
  // frozen. Three-arg callers are unchanged.
  function setStatus(el, msg, isError, retryFn) {
    if (!el) return;
    if (isError && typeof retryFn === 'function' && window.jvHubWarmError) {
      window.jvHubWarmError(el, retryFn, { message: msg });
      return;
    }
    var inProgress = !isError && msg && /…|\.\.\.|^(Saving|Sending|Uploading)/.test(msg);
    el.textContent = msg || '';
    el.className = 'jv-party-hub__status-msg'
      + (isError ? ' jv-party-hub__status-msg--error' : (msg ? ' jv-party-hub__status-msg--ok' : ''))
      + (inProgress ? ' jv-hub-saving' : '');
  }

  function badgeForStatus(status) {
    var map = {
      'completed':  { cls: 'jv-party-hub__badge--complete',    label: 'Complete' },
      'pending':    { cls: 'jv-party-hub__badge--pending',     label: 'Invite Sent: Pending' },
      'not_sent':   { cls: 'jv-party-hub__badge--not-started', label: 'Not Started' }
    };
    return map[status] || map['not_sent'];
  }

  // ── Invite-email duplicate guard (2026-07-18) ────────────────────────────
  // Email on a party member is an INVITE address, not an identity key. A shared
  // non-blank email used to silently merge two distinct people (Cherie's three
  // daughters collapsed to one). This pre-checks a typed email against the
  // already-loaded _members list AND the bride's own email, with no extra GAS
  // call (the list is already in memory). Blank is always allowed (safe path).
  // Returns the display name of the conflicting owner, or '' if the email is
  // free / blank. Case-insensitive on the trimmed value.
  function _normEmail(v) { return String(v == null ? '' : v).trim().toLowerCase(); }
  function _findEmailOwner(email, excludeIdx) {
    var e = _normEmail(email);
    if (!e) return '';                              // blank never collides
    if (e === _normEmail(customerEmail)) return 'you (the bride)';
    for (var i = 0; i < _members.length; i++) {
      if (excludeIdx != null && i === excludeIdx) continue;
      if (_normEmail(_members[i].email) === e) {
        return String(_members[i].name || '').trim() || 'another party member';
      }
    }
    return '';
  }
  // Live inline warning under the add-form email input. Shows/clears as the
  // bride types; never blocks typing (the hard block is at Save time).
  function _updateAddEmailWarn() {
    if (!addEmailWarn) return;
    var owner = addEmail ? _findEmailOwner(addEmail.value, null) : '';
    if (owner) {
      addEmailWarn.textContent = 'This email already belongs to ' + owner
        + '. Each person needs their own email to be invited, or leave it blank.';
      addEmailWarn.hidden = false;
    } else {
      addEmailWarn.textContent = '';
      addEmailWarn.hidden = true;
    }
  }
  if (addEmail) {
    addEmail.addEventListener('input', _updateAddEmailWarn);
    addEmail.addEventListener('blur', _updateAddEmailWarn);
  }

  // ── Load all members ─────────────────────────────────────────────────────
  function loadPartyMembers() {
    if (loading) loading.style.display = '';
    if (grid) grid.style.display = 'none';
    if (empty) empty.style.display = 'none';

    getPartyMembers(function (data) {
      if (loading) loading.style.display = 'none';
      if (!data || !data.success) {
        if (empty) {
          empty.style.display = '';
          var emptyHeading = empty.querySelector('.jv-party-hub__empty-heading');
          if (emptyHeading) emptyHeading.textContent = 'Could not load party members';
        }
        updatePill([]);
        return;
      }
      _members = data.members || [];
      updatePill(_members);
      if (_members.length === 0) {
        if (empty) empty.style.display = '';
        return;
      }
      if (grid) {
        grid.style.display = '';
        renderGrid(_members);
      }
    }, function () {
      if (loading) loading.style.display = 'none';
      if (empty) {
        empty.style.display = '';
        var emptyHeading = empty.querySelector('.jv-party-hub__empty-heading');
        if (emptyHeading) emptyHeading.textContent = 'Could not load. Please refresh';
      }
      updatePill([]);
    });
  }

  function renderGrid(members) {
    if (!grid) return;
    grid.innerHTML = '';
    _loadedCards = {};
    members.forEach(function (member, idx) {
      grid.appendChild(buildCard(member, idx));
    });
    wireCardEvents();
  }

  function buildCard(member, idx) {
    var badge = badgeForStatus(member.formStatus);
    var nameDisplay = (member.name || 'Unnamed').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var roleDisplay = (member.role || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var bodyId = 'jv-party-hub-body-' + idx;
    var nameParts = (member.name || '').trim().split(/\s+/);
    var initials = nameParts.length >= 2
      ? (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase()
      : (nameParts[0] || '?').slice(0, 2).toUpperCase();

    var placeholderMatch = (!member.email && !member.phone)
      ? /^(Bridesmaid|Mother of the Bride|Mother of the Groom|Mother|Flower Girl|Flowergirl|Guest|Party member)\s+(\d+)$/.exec(String(member.name || '').trim())
      : null;
    // Explicit empty-slot flag from the blob takes precedence over the name regex.
    var isPlaceholder = member.is_empty === true || member.slot_status === 'empty' || !!placeholderMatch;
    var placeholderRole = placeholderMatch ? placeholderMatch[1]
      : (isPlaceholder ? (member.slot_label ? String(member.slot_label).replace(/\s*\d+\s*$/, '') : (member.role ? member.role.replace(/\b\w/g, function(c){return c.toUpperCase();}) : 'Party member')) : '');
    var placeholderSlot = placeholderMatch ? placeholderMatch[2]
      : (isPlaceholder && member.slot_label ? (String(member.slot_label).match(/(\d+)\s*$/) || ['',''])[1] : '');

    var card = document.createElement('div');
    card.className = 'jv-party-hub__card' + (isPlaceholder ? ' jv-party-hub__card--unfilled' : '');
    card.setAttribute('data-member-index', idx);
    if (isPlaceholder) card.setAttribute('data-placeholder', '1');
    var identityHtml = isPlaceholder
      ? '<p class="jv-party-hub__card-name jv-party-hub__card-name--placeholder" title="Add a name for this ' + placeholderRole.toLowerCase() + '">Add a name</p>'
        + '<p class="jv-party-hub__card-role">' + placeholderRole + ' &middot; slot ' + placeholderSlot + '</p>'
      : '<p class="jv-party-hub__card-name" title="' + nameDisplay + '">' + nameDisplay + '</p>'
        + '<p class="jv-party-hub__card-role">' + roleDisplay + '</p>';
    card.innerHTML = [
      '<div class="jv-party-hub__card-header">',
        '<div class="jv-party-hub__avatar jv-party-hub__avatar--clickable" role="button" tabindex="0" aria-label="Upload profile photo" data-upload-idx="' + idx + '">' + (member.profilePicUrl ? '<img class="jv-party-hub__avatar-img" src="' + JV_driveImg(member.profilePicUrl).replace(/"/g, '') + '" alt="' + nameDisplay + '" loading="lazy">' : initials) + '</div>',
        '<div class="jv-party-hub__card-identity">',
          identityHtml,
          ((member.email || member.phone) ? (
            '<div class="jv-party-hub__card-contact">' +
              (member.email ? '<span class="jv-party-hub__card-contact-item" title="' + String(member.email).replace(/"/g,'&quot;') + '">' + String(member.email).replace(/</g,'&lt;') + '</span>' : '') +
              (member.phone ? '<span class="jv-party-hub__card-contact-item">' + String(member.phone).replace(/</g,'&lt;') + '</span>' : '') +
            '</div>'
          ) : ''),
          '<span class="jv-party-hub__badge ' + badge.cls + '" data-status="' + (member.formStatus || 'not_sent') + '">' + badge.label + '</span>',
        '</div>',
        '<div class="jv-party-hub__card-meta">',
          '<button type="button" class="jv-party-hub__edit-icon-btn js-party-hub-edit"',
            ' aria-label="Edit ' + nameDisplay + '" title="Edit ' + nameDisplay + '"',
            ' data-member-index="' + idx + '">',
            '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">',
              '<path d="M11 2.5l2.5 2.5L5 13.5H2.5V11z"/>',
              '<line x1="9.5" y1="4" x2="12" y2="6.5"/>',
            '</svg>',
            '<span class="jv-party-hub__edit-icon-btn-label">Edit</span>',
          '</button>',
          '<button type="button" class="jv-party-hub__expand-btn js-party-hub-expand"',
            ' aria-expanded="false" aria-controls="' + bodyId + '"',
            ' data-member-index="' + idx + '">',
            'View details',
            '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" class="jv-party-hub__expand-chevron" aria-hidden="true">',
              '<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>',
            '</svg>',
          '</button>',
        '</div>',
      '</div>',
      '<div class="jv-party-hub__card-body" id="' + bodyId + '" style="display:none;" aria-hidden="true">',
        '<p class="jv-party-hub__sub-heading">Inspiration Images</p>',
        '<div class="jv-party-hub__inspo-area" id="jv-hub-inspo-' + idx + '">',
          '<p class="jv-party-hub__loading-text" style="font-size:.8rem;">Loading images…</p>',
        '</div>',
        '<p class="jv-party-hub__sub-heading">Details</p>',
        '<div class="jv-party-hub__details-area" id="jv-hub-details-' + idx + '">',
          '<p class="jv-party-hub__loading-text" style="font-size:.8rem;">Loading details…</p>',
        '</div>',
        '<p class="jv-party-hub__sub-heading">Wedding Day Service</p>',
        '<div class="jv-party-hub__service-area" id="jv-hub-service-' + idx + '">',
          '<p class="jv-party-hub__loading-text" style="font-size:.8rem;">Loading…</p>',
        '</div>',
        '<div class="jv-party-hub__photo-area" id="jv-hub-photo-' + idx + '">',
          '<input type="file" class="jv-party-hub__pic-file-input" accept="image/*"',
            ' data-member-index="' + idx + '" aria-label="Upload profile photo"',
            ' style="position:absolute;width:1px;height:1px;opacity:0;overflow:hidden;">',
          '<p class="jv-party-hub__status-msg" id="jv-hub-photo-status-' + idx + '" aria-live="polite" style="font-size:.8rem;color:var(--brand-primary-deep);"></p>',
        '</div>',
        '<p class="jv-party-hub__sub-heading">Invite</p>',
        '<div class="jv-party-hub__invite-actions" id="jv-hub-invite-' + idx + '">',
          (member.email ? '<button type="button" class="jv-party-hub__btn jv-party-hub__btn--outline-sm js-party-hub-send-email" data-member-index="' + idx + '">Send invite email</button>' : '<span class="jv-party-hub__status-msg" style="opacity:.65;">No email on file</span>'),
          '<button type="button" class="jv-party-hub__btn jv-party-hub__btn--ghost js-party-hub-invite" data-member-index="' + idx + '">Copy link</button>',
          '<p class="jv-party-hub__status-msg" id="jv-hub-invite-status-' + idx + '" aria-live="polite"></p>',
        '</div>',
      '</div>'
    ].join('');
    return card;
  }

  function wireCardEvents() {
    if (!grid) return;

    grid.querySelectorAll('.js-party-hub-expand').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-member-index'), 10);
        var bodyId = 'jv-party-hub-body-' + idx;
        var body = document.getElementById(bodyId);
        if (!body) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        body.style.display = isOpen ? 'none' : '';
        body.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        // "People not records" reframe (2026-09-10): contact info (email/
        // phone) is hidden by default, CSS-revealed only on this same card
        // via .is-expanded -- see assets/jv-bridal-hub.css.
        var cardEl = btn.closest('.jv-party-hub__card');
        if (cardEl) cardEl.classList.toggle('is-expanded', !isOpen);
        if (!isOpen && !_loadedCards[idx]) {
          _loadedCards[idx] = true;
          loadCardDetails(idx);
        }
      });
    });

    // Edit button (top-right of each card) — expand the card if needed and
    // open the edit form directly. Two distinct buttons, two distinct actions
    // per Jess: View Details = expand, Edit = jump straight to edit mode.
    grid.querySelectorAll('.js-party-hub-edit').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-member-index'), 10);
        var bodyId = 'jv-party-hub-body-' + idx;
        var body = document.getElementById(bodyId);
        if (!body) return;
        var expandBtn = document.querySelector('.js-party-hub-expand[data-member-index="' + idx + '"]');
        if (body.style.display === 'none') {
          body.style.display = '';
          body.setAttribute('aria-hidden', 'false');
          if (expandBtn) expandBtn.setAttribute('aria-expanded', 'true');
          // Same is-expanded toggle the expand button's own handler uses
          // (assets/jv-bridal-hub.css), so Edit reveals contact info too.
          var editCardEl = btn.closest('.jv-party-hub__card');
          if (editCardEl) editCardEl.classList.add('is-expanded');
        }
        if (!_loadedCards[idx]) {
          _loadedCards[idx] = true;
          loadCardDetails(idx);
        }
        // Open the edit form once details are loaded. Profile data is hydrated
        // synchronously from the member object, so a short tick is enough.
        var member = _members[idx];
        if (!member) return;
        setTimeout(function () {
          var area = document.getElementById('jv-hub-details-' + idx);
          if (!area) return;
          var profile = {
            colourPalette: member.colourPalette || '',
            inspoNotes:    member.inspoNotes    || '',
            hairStyle:     member.hairStyle     || '',
            skinConcerns:  member.skinConcerns  || '',
            allergies:     member.allergies     || ''
          };
          renderEditForm(area, idx, member, profile);
          area.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 30);
      });
    });

    grid.querySelectorAll('.js-party-hub-invite').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-member-index'), 10);
        handleInviteLink(idx, btn);
      });
    });

    grid.querySelectorAll('.js-party-hub-send-email').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-member-index'), 10);
        handleSendInviteEmail(idx, btn);
      });
    });
  }

  // ── Load card details (lazy, on first expand) ─────────────────────────────
  function loadCardDetails(idx) {
    var member = _members[idx];
    if (!member) return;
    loadInspoImages(idx, member);
    loadTextDetails(idx, member);
    loadServiceDetails(idx, member);
  }

  function renderInspoArea(area, files, member) {
    area.innerHTML = '';

    function makeThumbWrap(f) {
      var wrap = document.createElement('div');
      wrap.style.cssText = 'position:relative;display:inline-block;line-height:0;';
      var a = document.createElement('a');
      a.href = f.url || f.thumbUrl;
      a.target = '_blank';
      a.rel = 'noopener';
      a.className = 'jv-party-hub__thumb-link';
      a.title = f.name || '';
      var img = document.createElement('img');
      var primarySrc = JV_driveImg(f.thumbUrl || f.url);
      img.src = primarySrc;
      // Fallback chain: if drive.google.com/thumbnail 403s (file not shared
      // ANYONE_WITH_LINK or transient Drive issue), try uc?export=view, then
      // lh3 — if all fail, leave the broken-image icon so the bug is visible.
      img.onerror = function () {
        if (img._jvFb1) {
          if (img._jvFb2) { img.onerror = null; return; }
          img._jvFb2 = true;
          img.src = f.fileId ? ('https://lh3.googleusercontent.com/d/' + f.fileId) : primarySrc;
        } else {
          img._jvFb1 = true;
          img.src = f.fileId ? ('https://drive.google.com/uc?export=view&id=' + f.fileId) : primarySrc;
        }
      };
      img.alt = f.name || 'Inspiration image';
      img.className = 'jv-party-hub__thumb';
      a.appendChild(img);
      wrap.appendChild(a);
      if (f.fileId) {
        var delBtn = document.createElement('button');
        delBtn.type = 'button';
        delBtn.className = 'jv-inspo-thumb__del';
        delBtn.setAttribute('aria-label', 'Remove photo');
        delBtn.innerHTML = '<svg viewBox="0 0 10 10" width="10" height="10" fill="none" stroke="#fff" stroke-width="1.75" stroke-linecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg>';
        (function(fRef, wRef, btnRef) {
          btnRef.addEventListener('click', function () {
            btnRef.disabled = true;
            wRef.style.opacity = '0.45';
            gasPost('bridge_party_deleteInspoImage', {
              memberContext: 'bride',
              targetMemberName: member.name,
              targetMemberRole: member.role || 'Party Member',
              targetMemberPmId: member.pm_id || '',
              fileId: fRef.fileId
            }, function (d) {
              if (d && d.ok) { wRef.remove(); _inspoCache[member.name] = null; }
              else { wRef.style.opacity = '1'; btnRef.disabled = false; }
            }, function () { wRef.style.opacity = '1'; btnRef.disabled = false; });
          });
        })(f, wrap, delBtn);
        wrap.appendChild(delBtn);
      }
      return wrap;
    }

    // Group by category — ProfilePic is shown in the avatar, not the grid
    var hairFiles   = [];
    var makeupFiles = [];
    var otherFiles  = [];
    files.forEach(function (f) {
      if (!f.thumbUrl || f.category === 'ProfilePic') return;
      if      (f.category === 'Hair')   hairFiles.push(f);
      else if (f.category === 'Makeup') makeupFiles.push(f);
      else                              otherFiles.push(f);
    });

    var groups = [
      { label: 'Hair',   files: hairFiles },
      { label: 'Makeup', files: makeupFiles },
      { label: 'Other',  files: otherFiles }
    ].filter(function (g) { return g.files.length > 0; });

    if (groups.length > 0) {
      groups.forEach(function (group) {
        var label = document.createElement('p');
        label.className = 'jv-party-hub__inspo-label';
        label.textContent = group.label;
        area.appendChild(label);
        var grid = document.createElement('div');
        grid.className = 'jv-party-hub__thumb-grid';
        group.files.forEach(function (f) { grid.appendChild(makeThumbWrap(f)); });
        area.appendChild(grid);
      });
    } else {
      var none = document.createElement('p');
      none.className = 'jv-party-hub__no-images';
      none.textContent = 'No images yet';
      area.appendChild(none);
    }

    var uploaderWrap = document.createElement('div');
    uploaderWrap.className = 'jv-party-hub__inspo-uploader';
    area.appendChild(uploaderWrap);
    if (typeof jvPartyInspoUpload_init === 'function') {
      jvPartyInspoUpload_init({
        containerEl: uploaderWrap,
        bridgeCall: bridgeCall,
        memberContext: 'bride',
        targetMemberName: member.name,
        targetMemberRole: member.role || 'Party Member',
        targetMemberPmId: member.pm_id || '',
        onSuccess: function (category, fileUrl, savedAs, result) {
          // Survive a RELOAD. _inspoCache is in-memory only, and on reload these
          // thumbs repaint from boot.inspoMeta (the bride_inspo_photos metafield),
          // which the hub's upload path never writes. Without this, a photo the
          // bride just uploaded disappears from view on refresh even though it is
          // safely in Drive. See FRESH-UPLOAD CACHE in jv-bride-spotlight.liquid.
          try { window.jvHubInspoRememberUpload(category, result && result.fileId); } catch (e) {}
          if (!_inspoCache[member.name]) _inspoCache[member.name] = [];
          // ALSO remember the full displayable entry per member (2026-08-08 fix).
          // The line above only stores a bare fileId, which is what the BRIDE's
          // spotlight grid needs, but a PARTY card renders {thumbUrl, category,
          // url}. Remembering just the id was half a fix: verified live
          // 2026-08-08, a member's SECOND photo vanished on reload and only
          // reappeared ~10 minutes later when the server list caught up.
          try {
            jvPartyInspoRemember_(member.name, {
              url: (result && result.fileUrl) || fileUrl,
              thumbUrl: (result && result.thumbUrl) ||
                        (result && result.fileId ? 'https://lh3.googleusercontent.com/d/' + result.fileId : '') ||
                        fileUrl,
              category: category,
              name: '',
              fileId: (result && result.fileId) || savedAs || ''
            });
          } catch (e) {}
          // Backend returns fileId + thumbUrl; fileUrl is the Drive `view` page
          // (not an image URL). Use thumbUrl for <img src>; fall back to a
          // synthesised lh3 URL from fileId, then to fileUrl as last resort.
          var thumb = (result && result.thumbUrl) ||
                      (result && result.fileId ? 'https://lh3.googleusercontent.com/d/' + result.fileId : '') ||
                      fileUrl;
          _inspoCache[member.name].push({
            url: (result && result.fileUrl) || fileUrl,
            thumbUrl: thumb,
            category: category,
            name: '',
            fileId: (result && result.fileId) || savedAs || ''
          });
        },
        onComplete: function (successes) {
          if (successes > 0) {
            // Re-render the persistent area with the updated cache so the
            // new thumbnails appear in INSPIRATION IMAGES above the uploader.
            renderInspoArea(area, jvPartyInspoMergeFresh_(member.name, _inspoCache[member.name] || []), member);
          }
        }
      });
    }
  }

  // PARTY INSPO IMAGES CDN CACHE (2026-09-10, PartyInspoImagesCache_2026_09_10.gs). Parsed
  // once at module scope from the jv-party-inspo-images-cache island (server-rendered from
  // customer.metafields.custom.party_inspo_images_json, sections/jv-bridal-hub.liquid).
  // Deliberately NOT written into _inspoCache directly at parse time: _inspoCache's existing
  // boot-time population (from party_blob's hair_inspo_urls/makeup_inspo_urls CSV, see the
  // _blobHydrated block below) is a real, already-live, already-proven source for this same
  // data and must keep winning where it has an answer. This island is a FALLBACK layer only,
  // consulted inside loadInspoImages() below when _inspoCache has nothing for a member yet.
  var _inspoImagesCdnCache = (function () {
    try {
      var el = document.getElementById('jv-party-inspo-images-cache');
      if (!el || !el.textContent) return null;
      var parsed = JSON.parse(el.textContent);
      if (!parsed || !parsed.members) return null;
      // sd-e22: by_pm (pm_id keyed, rename-proof) is exposed on the map under a reserved key so
      // existing name-keyed reads keep working; pm_id lookup is preferred in loadInspoImages().
      if (parsed.by_pm) { try { Object.defineProperty(parsed.members, '__by_pm', { value: parsed.by_pm, enumerable: false }); } catch (e2) {} }
      return parsed.members; // keyed by CURRENT member name, lowercased
    } catch (e) { return null; }
  })();

  function loadInspoImages(idx, member) {
    var area = document.getElementById('jv-hub-inspo-' + idx);
    if (!area) return;
    if (_inspoCache[member.name] !== undefined) {
      renderInspoArea(area, jvPartyInspoMergeFresh_(member.name, _inspoCache[member.name]), member);
      return;
    }
    // CDN fast path (2026-09-10): paint instantly from the island if it has this member,
    // then STILL background-refresh live below (stale-while-revalidate, same pattern as
    // every other bride-hub cache), so a card that just got a new upload self-corrects on
    // this same open rather than needing a second visit.
    var cdnFiles = null;
    if (_inspoImagesCdnCache) {
      var _byPm = _inspoImagesCdnCache.__by_pm;
      cdnFiles = (member.pm_id && _byPm && _byPm[member.pm_id]) || _inspoImagesCdnCache[String(member.name || '').trim().toLowerCase()] || null;
    }
    if (Array.isArray(cdnFiles)) {
      _inspoCache[member.name] = cdnFiles;
      renderInspoArea(area, jvPartyInspoMergeFresh_(member.name, cdnFiles), member);
    } else {
      // No island data for this member yet (cache not warmed, or a genuinely new member),
      // show the loading cue exactly as before. Live call is the only source in that case.
      area.innerHTML = '<p class="jv-party-hub__no-images">Loading inspiration images…</p>';
    }
    // This route scans the bride's Drive folder tree and can take ~30s+ on a
    // cold GAS instance, well past the gasPost default 15s abort. Use jvHubFetch
    // directly with a generous 45s timeout (same pattern as handleInviteLink)
    // so the (working but slow) call completes instead of falsely showing
    // "Could not load images".
    var onOk = function (data) {
      var files = (data && data.ok && data.files) ? data.files : [];
      _inspoCache[member.name] = files;
      // Merge recent uploads the server list may not have caught up on yet.
      renderInspoArea(area, jvPartyInspoMergeFresh_(member.name, files), member);
    };
    var onErr = function () {
      // Only show the hard failure state if the CDN island didn't already paint something.
      // A live-refresh failure on a card that's already showing real (if slightly stale)
      // photos should not regress the bride to an error message.
      if (!Array.isArray(cdnFiles)) area.innerHTML = '<p class="jv-party-hub__no-images">Could not load images</p>';
    };
    // sd-e34: flag-gated Cloudflare read by pm_id (stored folder id). OFF unless
    // window.JV_HUB_INSPO_BY_PMID = { url: '<mirror>/party-inspo/member-images' } is set.
    // Any non-mapped / failed / timed-out answer falls through to the existing GAS call below.
    var legacyInspoLoad = function () {
      if (window.jvHubFetch) {
        window.jvHubFetch('bridge_party_listInspoImages', {
          memberContext: 'bride',
          targetMemberName: member.name,
          targetMemberRole: member.role || 'Party Member'
        }, {
          email: customerEmail, customerId: customerId,
          timeoutMs: 45000,
          onOk: onOk,
          onErr: onErr
        });
      } else {
        gasPost('bridge_party_listInspoImages', {
          memberContext: 'bride',
          targetMemberName: member.name,
          targetMemberRole: member.role || 'Party Member'
        }, onOk, onErr);
      }
    };
    var byPm = window.JV_HUB_INSPO_BY_PMID;
    if (byPm && byPm.url && member.pm_id) {
      var nf = (window._jvNativeFetch || window.fetch).bind(window);
      var done = false;
      var tm = setTimeout(function () { if (!done) { done = true; legacyInspoLoad(); } }, byPm.timeoutMs || 8000);
      nf(byPm.url, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({ brideEmail: customerEmail, customerId: customerId, pmId: member.pm_id }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (done) return; done = true; clearTimeout(tm);
          if (d && d.ok && d.linkState === 'mapped' && Array.isArray(d.files)) onOk({ ok: true, files: d.files });
          else legacyInspoLoad();
        })
        .catch(function () { if (done) return; done = true; clearTimeout(tm); legacyInspoLoad(); });
    } else {
      legacyInspoLoad();
    }
  }

  function loadTextDetails(idx, member) {
    var area = document.getElementById('jv-hub-details-' + idx);
    if (!area) return;
    var renderFromMember = function () {
      renderDetailsReadOnly(area, idx, member, {
        colourPalette: member.colourPalette || '',
        inspoNotes:    member.inspoNotes    || '',
        hairStyle:     member.hairStyle     || '',
        skinConcerns:  member.skinConcerns  || '',
        allergies:     member.allergies     || ''
      });
    };
    // Fast path: profile fields are hydrated from the embedded jv_party_members_json
    // blob at init (the _blobHydrated block sets _profileCache for every blob-matched
    // member; the gated getPartyMembers fallback sets the member fields directly), so
    // render straight from the member object with zero GAS.
    var hydrated = (_profileCache[member.name] !== undefined) ||
                   (member.colourPalette !== undefined) ||
                   (member.hairStyle    !== undefined) ||
                   (member.skinConcerns !== undefined) ||
                   (member.allergies    !== undefined) ||
                   (member.inspoNotes   !== undefined);
    if (hydrated) { renderFromMember(); return; }
    // Lazy per-member fallback: this member is absent from the blob (name mismatch,
    // or added since the last sync). Fetch THIS member's profile only, on expand,
    // never in a load-time loop over all members. Render what we have first so the
    // card never looks empty while the single call resolves.
    renderFromMember();
    gasPost('bridge_guest_getProfile', { memberName: member.name }, function (data) {
      var p = (data && data.success && data.profile) ? data.profile : {};
      if (p.colourPalette) member.colourPalette = p.colourPalette;
      if (p.inspoNotes)    member.inspoNotes    = p.inspoNotes;
      if (p.hairStyle)     member.hairStyle     = p.hairStyle;
      if (p.skinConcerns)  member.skinConcerns  = p.skinConcerns;
      if (p.allergies)     member.allergies     = p.allergies;
      _profileCache[member.name] = {
        colourPalette: member.colourPalette || '',
        inspoNotes:    member.inspoNotes    || '',
        hairStyle:     member.hairStyle     || '',
        skinConcerns:  member.skinConcerns  || '',
        allergies:     member.allergies     || ''
      };
      renderFromMember();
    }, function () {
      // Mark as resolved (empty) so re-renders within this session do not refetch.
      _profileCache[member.name] = {};
    });
  }

  function renderDetailsReadOnly(area, idx, member, profile) {
    area.innerHTML = '';
    var fields = [
      { label: 'Colour palette', val: profile.colourPalette },
      { label: 'Hair notes',     val: profile.inspoNotes },
      { label: 'Hair style',     val: profile.hairStyle },
      { label: 'Skin concerns',  val: profile.skinConcerns },
      { label: 'Allergies',      val: profile.allergies }
    ];
    var detailGrid = document.createElement('div');
    detailGrid.className = 'jv-party-hub__detail-grid';
    fields.forEach(function (f) {
      var row = document.createElement('div');
      row.className = 'jv-party-hub__detail-row';
      var hasVal = f.val && f.val.trim();
      row.innerHTML = [
        '<span class="jv-party-hub__detail-label">' + f.label + '</span>',
        '<span class="jv-party-hub__detail-value' + (hasVal ? '' : ' jv-party-hub__detail-value--empty') + '">',
          hasVal ? (f.val).replace(/</g,'&lt;').replace(/>/g,'&gt;') : '&middot;',
        '</span>'
      ].join('');
      detailGrid.appendChild(row);
    });
    area.appendChild(detailGrid);
    // No inline Edit button here — the top-right card Edit pill (.js-party-hub-edit)
    // handles entering edit mode. Keeping both was visually duplicative.
  }

  function renderEditForm(area, idx, member, prefill) {
    area.innerHTML = '';
    var form = document.createElement('div');
    form.className = 'jv-party-hub__proxy-form';

    // HAIRSTYLE_OPTIONS is the shared module-scope array (see top of IIFE).
    // If a future bride somehow has a value not in any option (canonical OR legacy),
    // append it inline so re-edit doesn't silently revert to "— Select a style —".
    var _hsOpts = HAIRSTYLE_OPTIONS.slice();
    if (prefill.hairStyle && !_hsOpts.some(function (o) { return o.value === prefill.hairStyle; })) {
      _hsOpts.push({ value: prefill.hairStyle, label: prefill.hairStyle + ' (unknown)' });
    }

    function field(id, labelText, isTextarea, val, options) {
      var wrap = document.createElement('div');
      wrap.className = 'jv-party-hub__field';
      var lbl = document.createElement('label');
      lbl.className = 'jv-party-hub__field-label';
      lbl.setAttribute('for', id + '-' + idx);
      lbl.textContent = labelText;
      var input;
      if (options && options.length) {
        input = document.createElement('select');
        options.forEach(function (opt) {
          var o = document.createElement('option');
          o.value = opt.value;
          o.textContent = opt.label;
          if (val && opt.value === val) o.selected = true;
          input.appendChild(o);
        });
      } else {
        input = document.createElement(isTextarea ? 'textarea' : 'input');
        input.value = val || '';
        if (!isTextarea) input.type = 'text';
      }
      input.id = id + '-' + idx;
      input.className = isTextarea ? 'jv-party-hub__field-textarea' : 'jv-party-hub__field-input';
      wrap.appendChild(lbl);
      wrap.appendChild(input);
      return wrap;
    }

    // Profile photo: clicking the avatar circle on the card already opens the
    // file picker via .jv-party-hub__avatar--clickable. A second "Add photo"
    // button in the edit form is redundant — removed per Jess feedback 2026-05-14.

    // Name edit (Path A bridal-party brief, 2026-05-25). Only shown for real
    // members (skipped when pm_id is missing — placeholder cards use the
    // existing portalUpdatePartyMembers flow on first fill).
    var originalName = String(member.name || '').trim();
    if (member.pm_id) {
      form.appendChild(field('hub-edit-name', 'Member name', false, originalName));
    }

    form.appendChild(field('hub-edit-colour',    'Colour palette / mood', true,  prefill.colourPalette));
    form.appendChild(field('hub-edit-hair',      'Hair inspiration notes', true, prefill.inspoNotes));
    form.appendChild(field('hub-edit-hairstyle', 'Hair style',            false, prefill.hairStyle, _hsOpts));
    form.appendChild(field('hub-edit-skin',      'Skin concerns',          true, prefill.skinConcerns));
    form.appendChild(field('hub-edit-allergies', 'Allergies',             false, prefill.allergies));

    var actions = document.createElement('div');
    actions.className = 'jv-party-hub__form-actions';

    var saveBtn = document.createElement('button');
    saveBtn.type = 'button';
    saveBtn.className = 'jv-party-hub__btn jv-party-hub__btn--primary';
    saveBtn.textContent = 'Save details';

    var cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = 'jv-party-hub__proxy-cancel';
    cancelBtn.textContent = 'Cancel';

    var statusEl = document.createElement('p');
    statusEl.className = 'jv-party-hub__status-msg';
    statusEl.setAttribute('aria-live', 'polite');

    actions.appendChild(saveBtn);
    actions.appendChild(cancelBtn);
    actions.appendChild(statusEl);
    form.appendChild(actions);

    // Remove-from-party link (soft-delete with confirm modal). Real members only.
    if (member.pm_id) {
      var removeWrap = document.createElement('div');
      removeWrap.className = 'jv-party-hub__remove-wrap';
      removeWrap.style.cssText = 'margin-top:1.25rem;padding-top:1rem;border-top:1px solid rgba(0,0,0,0.06);display:flex;justify-content:flex-end';
      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'jv-party-hub__remove-btn';
      removeBtn.style.cssText = 'background:none;border:none;color:#a64545;font-family:inherit;font-size:.85rem;cursor:pointer;padding:.35rem .5rem;text-decoration:underline;text-underline-offset:3px';
      removeBtn.textContent = 'Remove from party';
      removeBtn.addEventListener('click', function () {
        openDeleteMemberConfirm(idx, member);
      });
      removeWrap.appendChild(removeBtn);
      form.appendChild(removeWrap);
    }

    area.appendChild(form);

    cancelBtn.addEventListener('click', function () {
      loadTextDetails(idx, member);
    });

    saveBtn.addEventListener('click', doSaveMember);
    function doSaveMember() {
      var formData = {
        colourPalette: (document.getElementById('hub-edit-colour-'    + idx) || {}).value || '',
        inspoNotes:    (document.getElementById('hub-edit-hair-'      + idx) || {}).value || '',
        hairStyle:     (document.getElementById('hub-edit-hairstyle-' + idx) || {}).value || '',
        skinConcerns:  (document.getElementById('hub-edit-skin-'      + idx) || {}).value || '',
        allergies:     (document.getElementById('hub-edit-allergies-' + idx) || {}).value || ''
      };
      var newName = '';
      if (member.pm_id) {
        newName = String((document.getElementById('hub-edit-name-' + idx) || {}).value || '').trim();
      }
      Object.assign(member, formData);
      saveBtn.disabled = true;
      setStatus(statusEl, 'Saving… this can take up to 20 seconds.');

      // The name change and the profile-fields save are INDEPENDENT writes to
      // different backends (rename goes to _PartyMembers MEMBER_NAME + metaobject;
      // profile goes to SERVICE_DATA_JSON). A name-only change must NOT be gated
      // behind the profile save succeeding. For a freshly-named empty slot the
      // profile save can legitimately fail/no-op, and that used to dead-end with
      // "That didn't save" so the rename never ran. We now fire the rename on its
      // own and treat the profile save as best-effort. (2026-06-28 fix.)
      var wantsRename = !!(newName && newName !== originalName);

      // Paint the new name into the CURRENT _members entry (matched by pm_id, name
      // fallback) so a later renderGrid stays correct.
      function applyNameToMembers() {
        for (var _mi = 0; _mi < _members.length; _mi++) {
          var _same = (member.pm_id && _members[_mi].pm_id === member.pm_id)
                   || (!member.pm_id && _members[_mi].name === originalName);
          if (_same) { _members[_mi].name = newName; break; }
        }
        member.name = newName;
      }

      // Surgically set this one card's visible name text in place (no grid rebuild).
      function paintCardName(nameToShow) {
        var card = grid ? grid.querySelector('.jv-party-hub__card[data-member-index="' + idx + '"]') : null;
        if (!card) return;
        var nameEl = card.querySelector('.jv-party-hub__card-name');
        if (!nameEl || !nameToShow) return;
        nameEl.textContent = nameToShow;
        nameEl.setAttribute('title', nameToShow);
        nameEl.classList.remove('jv-party-hub__card-name--placeholder');
        card.classList.remove('jv-party-hub__card--unfilled');
        card.removeAttribute('data-placeholder');
      }

      // OPTIMISTIC UPDATE: the rename write can take ~16-25s on a cold GAS instance.
      // Paint the new name on the card the instant Save is pressed so it feels
      // immediate; the background write confirms it. On failure we revert to the
      // original name. (2026-06-29.)
      if (wantsRename) paintCardName(newName);

      function doRename(onDone) {
        // The rename handler does CRM sheet writes + TWO Shopify GraphQL writes
        // (syncBlob metafield + metaobject member_name). On a cold GAS instance
        // that runs ~16-25s, well past the gasPost default 15s abort, so the call
        // was timing out and showing "That name didn't save" even though the server
        // wrote successfully (the rename persisted on reload). Use jvHubFetch with a
        // 45s timeout, same fix family as loadInspoImages / loadServiceDetails /
        // the invite-link timeout fixes. (Root-caused 2026-06-29.)
        //
        // FIXED 2026-08-20 (BRIEFS/RESULTS-verify-party-rename-delete-fix-2026-08-20.md
        // + PartyRenameDiagnostic_2026_08_20.gs): the SAME false-failure this file's
        // own 2026-06-29 comment already describes recurred, worse. A live diagnostic
        // fired the identical HTTP call the browser makes and measured 80s -- past
        // even the 45s bump. The 45s client timeout fires, aborts the fetch, shows
        // this exact error, while the abandoned server-side request keeps running and
        // completes successfully moments later (confirmed: the diagnostic's own call
        // returned {success:true} at 80s). The bride sees a false failure on a save
        // that actually worked, identical to the bug this timeout was raised to fix
        // in the first place -- raising the number again only postpones the next
        // recurrence.
        //
        // Fix: on a TIMEOUT specifically (not an explicit server rejection), verify
        // via a fresh read before reverting/erroring, same principle as this file's
        // own verifyMemberSaved() used elsewhere (go to the data, don't assume from
        // an ambiguous client-side signal). A timeout is genuinely ambiguous -- the
        // write may have landed after the client gave up -- an explicit {success:false}
        // is not ambiguous and still reverts immediately, unchanged.
        var renameOk = function (rd) {
          if (!rd || !rd.success) {
            // Server rejected the rename: revert the optimistic card paint.
            paintCardName(originalName);
            saveBtn.disabled = false;
            setStatus(statusEl, (rd && rd.error) || "That name didn't save. Please try again.", true, doSaveMember);
            return;
          }
          applyNameToMembers();
          if (onDone) onDone();
        };
        var renameErr = function () {
          // Ambiguous outcome: the client gave up waiting, but the server may still
          // complete the write after this point (proven live, see comment above).
          // Check the actual data before telling the bride it failed.
          setStatus(statusEl, 'Still checking…');
          verifyMemberSaved({ pm_id: member.pm_id, name: newName, requireNameMatch: true, timeoutMs: 45000 }, function (found, members) {
            if (found) {
              // The rename DID land -- the timeout was a false alarm. Confirm it as
              // a real success rather than a false failure.
              applyNameToMembers();
              if (onDone) onDone();
              return;
            }
            // Genuinely not there yet (or the verify read itself failed) -- revert
            // and let the bride retry, same as before.
            paintCardName(originalName);
            saveBtn.disabled = false;
            setStatus(statusEl, "That name didn't save. Please try again.", true, doSaveMember);
          });
        };
        // D1 fast-path wiring (2026-11-02, same pattern as generateInviteLink):
        // window.jvHubPartyCrud.renamePartyMember falls straight through to the
        // EXACT SAME bridge_bride_renamePartyMember GAS call below whenever
        // window.JV_HUB_PARTY_CRUD_FASTPATH.renamePartyMember is not explicitly
        // set true (its own default) -- byte-identical behaviour while that
        // flag stays off.
        if (window.jvHubPartyCrud && window.jvHubPartyCrud.renamePartyMember) {
          window.jvHubPartyCrud.renamePartyMember(member.pm_id, newName, {
            email: customerEmail, customerId: customerId,
            timeoutMs: 45000,
            onOk: renameOk,
            onErr: renameErr
          });
        } else if (window.jvHubFetch) {
          window.jvHubFetch('bridge_bride_renamePartyMember', {
            pm_id: member.pm_id,
            newName: newName
          }, {
            email: customerEmail, customerId: customerId,
            timeoutMs: 45000,
            onOk: renameOk,
            onErr: renameErr
          });
        } else {
          gasPost('bridge_bride_renamePartyMember', {
            pm_id: member.pm_id,
            newName: newName
          }, renameOk, renameErr);
        }
      }

      function finishSaved() {
        saveBtn.disabled = false;
        setStatus(statusEl, 'Saved');
        updatePill(_members);
        // The card name was already painted optimistically on Save; re-assert it
        // here (covers the no-rename profile-only path too). No renderGrid() so the
        // grid is not wiped + rebuilt (that full redraw collapses expanded cards
        // and jumps the scroll, reading as a whole-page reload). (2026-06-29.)
        if (newName) paintCardName(newName);
        // Collapse the edit form back to the read-only detail view for this card.
        loadTextDetails(idx, member);
      }

      // LOCAL-FIRST SAVE (Build Doctrine 2, rebuilt 2026-08-06).
      //
      // The bride no longer waits on GAS to be told her details saved. The
      // profile fields were already merged into `member` above, so the local
      // state IS the confirmed state: we collapse straight back to the read-only
      // view and let the durable write run in the background.
      //
      // Why this is safe rather than optimistic-and-hopeful:
      //  - The essential CRM writes (SERVICE_DATA_JSON + the _PartyMembers
      //    profile columns) are SYNCHRONOUS server-side and complete before the
      //    handler returns (PortalForms.gs FAST-RETURN, ~1-3s of real work).
      //  - The slow Shopify tail (blob metafield + metaobject upsert + republish
      //    nudge) is already deferred to jvPartyDefer_run, which is idempotent,
      //    re-derives state from the sheets, retries up to 3 times and logs a
      //    failure to the Workflow Audit Log. It owns its own alerting.
      //  - So the only thing the client was ever waiting for was confirmation of
      //    a write that had already happened.
      //
      // A confirmed item is never silently lost: if the request genuinely fails
      // (network down, auth rejected, server error) we re-surface the error with
      // a retry affordance and drop the stale profile cache. She is never told it
      // worked when it did not.
      var savedFormData = formData;      // her typed values, for a retry
      var savedName     = member.name;   // pre-write name, for cache invalidation

      function reportSaveFailure(reason) {
        // Fail LOUD to the bride ONLY in the sense of "not saved, try again",
        // never with a technical message. Admin-side alerting is the deferred
        // queue's job (server-side), not the browser's.
        try {
          console.error('[bridal-hub] party profile save failed for "' +
                        savedName + '" (' + (reason || 'unknown') + ')');
        } catch (_) {}
        // Drop the stale cache so nothing renders her unsaved values as saved.
        delete _profileCache[savedName];

        // CRITICAL: we already confirmed and collapsed the editor, so the
        // `statusEl` and `saveBtn` captured in this closure were destroyed by
        // renderDetailsReadOnly's `area.innerHTML = ''`. Writing the error into
        // those detached nodes would be INVISIBLE to the bride, i.e. a silently
        // lost save, which is the one outcome optimistic UI must never produce.
        // Re-open the edit form for this card, PREFILLED with the values she
        // typed, so the message lands somewhere she can see and a retry costs
        // her nothing. renderEditForm builds fresh statusEl/saveBtn closures and
        // rebinds doSaveMember, so the retry path is fully live again.
        var area = document.getElementById('jv-hub-details-' + idx);
        if (area) {
          renderEditForm(area, idx, member, {
            colourPalette: savedFormData.colourPalette || '',
            inspoNotes:    savedFormData.inspoNotes    || '',
            hairStyle:     savedFormData.hairStyle     || '',
            skinConcerns:  savedFormData.skinConcerns  || '',
            allergies:     savedFormData.allergies     || ''
          });
          var reStatus = area.querySelector('.jv-party-hub__status-msg');
          var reSave   = area.querySelector('.jv-party-hub__btn--primary');
          if (reSave) reSave.disabled = false;
          if (reStatus) {
            setStatus(reStatus, "That didn't save. Please try again.", true, function () {
              var btn = area.querySelector('.jv-party-hub__btn--primary');
              if (btn) btn.click();
            });
          }
          return;
        }
        // Fallback: the card is gone from the DOM. Still never claim success.
        saveBtn.disabled = false;
        setStatus(statusEl, "That didn't save. Please try again.", true, doSaveMember);
      }

      var proxyOk = function (data) {
        if (data && data.success) {
          if (data.members) _members = data.members;
          return; // already confirmed to the bride
        }
        // Server explicitly rejected the write (auth, missing row, bad payload).
        // This is a REAL failure, not a timeout, so surface it and let her retry.
        reportSaveFailure((data && (data.error || data.message)) || 'server rejected');
      };
      var proxyErr = function (info) {
        // Transport failure or client timeout. The write may still have landed,
        // but we must not claim a success we cannot see, so surface it. The
        // deferred queue self-heals the durable side either way.
        reportSaveFailure((info && info.reason) || 'network');
      };

      // Confirm to the bride NOW, from local state, before the request goes out.
      if (wantsRename) {
        // Rename is a separate write with its own optimistic paint + revert.
        doRename(finishSaved);
      } else {
        finishSaved();
      }

      // D1 fast-path wiring (2026-11-02, same pattern as generateInviteLink):
      // window.jvHubPartyCrud.submitProxyOnboarding falls straight through to
      // the EXACT SAME bridge_bride_submitProxyOnboarding GAS call below
      // whenever window.JV_HUB_PARTY_CRUD_FASTPATH.submitProxyOnboarding is
      // not explicitly set true (its own default), or pm_id is empty (the
      // adapter requires it) -- byte-identical behaviour while the flag
      // stays off.
      if (window.jvHubPartyCrud && window.jvHubPartyCrud.submitProxyOnboarding) {
        window.jvHubPartyCrud.submitProxyOnboarding(member.pm_id || '', idx, savedFormData, {
          email: customerEmail, customerId: customerId,
          timeoutMs: 45000,
          onOk: proxyOk,
          onErr: proxyErr
        });
      } else if (window.jvHubFetch) {
        window.jvHubFetch('bridge_bride_submitProxyOnboarding', {
          memberIndex: idx,
          pmId: member.pm_id || '',
          formData: savedFormData
        }, {
          email: customerEmail, customerId: customerId,
          timeoutMs: 45000,
          onOk: proxyOk,
          onErr: proxyErr
        });
      } else {
        gasPost('bridge_bride_submitProxyOnboarding', {
          memberIndex: idx,
          pmId: member.pm_id || '',
          formData: savedFormData
        }, proxyOk, proxyErr);
      }
    }
  } // end renderEditForm. This closing brace was missing, which broke ALL party-hub handler binding (Add / Edit / View did nothing). Fixed 2026-06-27.

  // Remove-member modal: contact-team gate (2026-05-28).
  // Brides cannot self-remove party members. Roster changes affect the
  // published runsheet and require admin action. This modal redirects
  // the bride to email the team with a reason.
  function openDeleteMemberConfirm(idx, member) {
    var existing = document.getElementById('jv-party-hub-delete-modal');
    if (existing) existing.remove();

    var safeName = String(member.name || 'this member').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    var subject  = encodeURIComponent('Party member removal request - ' + safeName);
    var body     = encodeURIComponent('Hi team,\n\nI would like to remove ' + (member.name || 'a party member') + ' from my bridal party.\n\nReason: ');
    var mailto   = 'mailto:hello@jessicavegas.com?subject=' + subject + '&body=' + body;

    var overlay = document.createElement('div');
    overlay.id = 'jv-party-hub-delete-modal';
    overlay.className = 'jv-party-hub-delete-overlay';

    var modal = document.createElement('div');
    modal.className = 'jv-party-hub-delete-dialog';

    modal.innerHTML = [
      '<h3>Need to remove a party member?</h3>',
      '<p>',
        'Because your runsheet and booking details are linked to your bridal party, ',
        'our team needs to handle this change for you.',
      '</p>',
      '<p>',
        'Simply email us with the name of the person you\'d like to remove and we\'ll sort it straight away.',
      '</p>',
      '<div class="jv-party-hub-delete-actions">',
        '<button type="button" id="jv-party-hub-delete-cancel" class="jv-party-hub-delete-cancel-btn">Cancel</button>',
        '<a href="' + mailto + '" class="jv-party-hub-delete-email-btn">',
          'Email our team',
        '</a>',
      '</div>'
    ].join('');
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    var closeOverlay = function () { try { overlay.remove(); } catch (e) {} };
    document.getElementById('jv-party-hub-delete-cancel').addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') { closeOverlay(); document.removeEventListener('keydown', escHandler); }
    });
  }

  // Parse the jv_runsheet_json blob once (embedded by the Liquid section as the
  // jv-runsheet-blob-data JSON island). Serves party-card wedding-day timing
  // without a GAS call. Null when no published runsheet exists yet.
  // Re-landed 2026-07-11 (the 3B reader from commit 36a7fbb7 was lost in the
  // db2484fe reconcile) so the party-blob timing write can later be retired.
  var _rsBlob = null;
  (function () {
    var el = document.getElementById('jv-runsheet-blob-data');
    if (!el) return;
    try { _rsBlob = JSON.parse(el.textContent); } catch (_) {}
  })();

  // Look up service/artist/startTime for a party member by name from the runsheet
  // blob. Returns null when the blob is absent or the name is not found.
  function _getServiceFromRunsheet(memberName) {
    if (!_rsBlob) return null;
    var people = (_rsBlob.sourceServices && _rsBlob.sourceServices.length)
      ? _rsBlob.sourceServices
      : (_rsBlob.services || _rsBlob.people || []);
    var nameLower = String(memberName || '').trim().toLowerCase();
    for (var i = 0; i < people.length; i++) {
      var p = people[i];
      var pn = String(p.personLabel || p.person || p.name || p.client || '').trim().toLowerCase();
      if (pn && pn === nameLower) return p;
    }
    return null;
  }

  function _renderServiceDetail(area, service, artist, startTime) {
    area.innerHTML = '';
    var detailGrid = document.createElement('div');
    detailGrid.className = 'jv-party-hub__detail-grid';
    [
      { label: 'Service',    val: service },
      { label: 'Artist',     val: artist },
      { label: 'Start time', val: startTime }
    ].forEach(function (f) {
      if (!f.val) return;
      var row = document.createElement('div');
      row.className = 'jv-party-hub__detail-row';
      row.innerHTML = [
        '<span class="jv-party-hub__detail-label">' + f.label + '</span>',
        '<span class="jv-party-hub__detail-value">' + String(f.val).replace(/</g,'&lt;').replace(/>/g,'&gt;') + '</span>'
      ].join('');
      detailGrid.appendChild(row);
    });
    if (detailGrid.children.length === 0) {
      area.innerHTML = '<p class="jv-party-hub__service-notice">Service details not yet assigned.</p>';
    } else {
      area.appendChild(detailGrid);
    }
  }

  function loadServiceDetails(idx, member) {
    var area = document.getElementById('jv-hub-service-' + idx);
    if (!area) return;
    // Fast path 1: runsheet blob (jv_runsheet_json CDN metafield). Single source
    // of truth for wedding-day timing; avoids duplicating it in the party blob.
    var rsEntry = _getServiceFromRunsheet(member && member.name);
    if (rsEntry && (rsEntry.service || rsEntry.serviceName || rsEntry.artist || rsEntry.assignedArtist || rsEntry.startTime || rsEntry.start_time)) {
      _renderServiceDetail(
        area,
        rsEntry.service || rsEntry.serviceName,
        rsEntry.artist  || rsEntry.assignedArtist,
        rsEntry.startTime || rsEntry.start_time
      );
      return;
    }
    // Fast path 2 (legacy fallback): party blob still carries service data for
    // brides whose runsheet blob predates this reader or is not yet built.
    if (member && (member.service || member.artist || member.start_time)) {
      _renderServiceDetail(area, member.service, member.artist, member.start_time);
      return;
    }
    // Fallback for legacy brides with stale blob (original GAS path).
    // bridge_party_getRunsheet reads the published runsheet snapshot and can take
    // ~30s+ on a cold GAS instance, past the gasPost default 15s abort. Use
    // jvHubFetch with a 45s timeout plus a loading cue (same pattern as the inspo
    // and invite-link routes) so it does not falsely show "Could not load service details".
    area.innerHTML = '<p class="jv-party-hub__service-notice">Loading service details…</p>';
    var onOk = function (data) {
      if (!data || !data.ok || !data.runsheet) {
        area.innerHTML = '<p class="jv-party-hub__service-notice">Runsheet not yet available. Check back closer to the wedding.</p>';
        return;
      }
      var rows = data.runsheet.rows || data.runsheet.schedule || [];
      var memberRow = null;
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (r.name && r.name.toLowerCase() === (member.name || '').toLowerCase()) {
          memberRow = r; break;
        }
      }
      if (!memberRow) {
        area.innerHTML = '<p class="jv-party-hub__service-notice">No service found for this member in the runsheet yet.</p>';
        return;
      }
      _renderServiceDetail(
        area,
        memberRow.service || memberRow.serviceName,
        memberRow.artist  || memberRow.artistName,
        memberRow.startTime
      );
    };
    var onErr = function () {
      area.innerHTML = '<p class="jv-party-hub__service-notice">Could not load service details.</p>';
    };
    if (window.jvHubFetch) {
      window.jvHubFetch('bridge_party_getRunsheet', {
        targetMemberName: member.name,
        targetMemberRole: member.role || 'Party Member'
      }, {
        email: customerEmail, customerId: customerId,
        timeoutMs: 45000,
        onOk: onOk,
        onErr: onErr
      });
    } else {
      gasPost('bridge_party_getRunsheet', {
        targetMemberName: member.name,
        targetMemberRole: member.role || 'Party Member'
      }, onOk, onErr);
    }
  }

  function handleInviteLink(idx, btn) {
    var member = _members[idx];
    if (!member) return;
    var statusEl = document.getElementById('jv-hub-invite-status-' + idx);
    btn.disabled = true;
    setStatus(statusEl, 'Generating link… this can take a few seconds.');
    // F1b (2026-07-19): use the FAST invite route bridge_party_generateInviteLink,
    // not the old bridge_bride_generatePartyLink. The old route called
    // partyMember_createOrUpdate WITHOUT sheetOnly, running the full ~5-call Shopify
    // GraphQL tail inline (~45s cold), which blew past the client timeout and 503'd
    // every time (live trace 5/5). The fast route skips createOrUpdate: it just
    // findActive-or-generate a token (single sheet append) plus one non-fatal
    // metaobject upsert, returning in ~8-10s. The member row already exists (the
    // bride added the member first), so createOrUpdate is not needed here. Payload is
    // the flat { memberName, memberEmail, memberRole }; response is { ok, url }.
    // Timeout raised to 45s for headroom (was 30s). See BUILD-F1b-fix-copy-invite-link-503.
    var _invitePayload = {
      memberName:  member.name,
      memberEmail: member.email || '',
      memberRole:  member.role || 'Party Member'
    };
    // Issue #11 Option A wiring (Sub-E, 2026-11-02): route through the
    // jvHubPartyCrud.generateInviteLink D1 fast-path adapter (shipped dark
    // 2026-10-27, see jv-bridal-hub-resilience.js) instead of calling GAS
    // directly here. The adapter itself falls straight through to the EXACT
    // SAME bridge_party_generateInviteLink GAS call below whenever
    // window.JV_HUB_PARTY_CRUD_FASTPATH.generateInviteLink is not explicitly
    // set true (its own default) -- so at every flag's default (off), this
    // produces byte-identical behaviour to the previous direct call. Only
    // when BOTH the browser flag AND the two Worker-side flags
    // (PARTY_INVITE_LINK_BRIDE_CF_ENABLED + _SCOPE_EMAILS) are armed does a
    // real call ever reach D1 instead of GAS.
    var doFetch = (window.jvHubPartyCrud && window.jvHubPartyCrud.generateInviteLink)
      ? function (onOk, onErr) {
          window.jvHubPartyCrud.generateInviteLink(member.name, member.email || '', member.role || 'Party Member', {
            email: customerEmail, customerId: customerId,
            timeoutMs: 45000,
            onOk: onOk,
            onErr: onErr
          });
        }
      : window.jvHubFetch
      ? function (onOk, onErr) {
          window.jvHubFetch('bridge_party_generateInviteLink', _invitePayload, {
            email: customerEmail, customerId: customerId,
            timeoutMs: 45000,
            onOk: onOk,
            onErr: onErr
          });
        }
      : function (onOk, onErr) {
          // Fallback when resilience asset not loaded: plain gasPost uses 15s default
          gasPost('bridge_party_generateInviteLink', _invitePayload, onOk, onErr);
        };
    doFetch(
      function (data) {
        btn.disabled = false;
        // Fast route returns { ok, url }; keep success/guestUrl fallbacks for safety.
        if (!data || (!data.ok && !data.success)) {
          setStatus(statusEl, (data && (data.error || data.message)) || 'Could not generate link.', true);
          return;
        }
        var url = data.url || data.guestUrl || '';
        if (!url) { setStatus(statusEl, 'No link returned.', true); return; }
        // Always show the URL so it's accessible even if clipboard fails
        setStatus(statusEl, url);
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            showToast('Invite link copied to clipboard');
          }).catch(function () {
            fallbackCopy(url);
          });
        } else {
          fallbackCopy(url);
        }
      },
      function () {
        btn.disabled = false;
        setStatus(statusEl, 'Network error. Please try again.', true);
      }
    );
  }

  function fallbackCopy(url) {
    var ta = document.createElement('textarea');
    ta.value = url;
    ta.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0;';
    document.body.appendChild(ta);
    ta.focus(); ta.select();
    try {
      var ok = document.execCommand('copy');
      if (ok) showToast('Invite link copied to clipboard');
    } catch (e) {}
    document.body.removeChild(ta);
  }

  // ── Send invite email ────────────────────────────────────────────────────
  function handleSendInviteEmail(idx, btn) {
    var member = _members[idx];
    if (!member || !member.email) return;
    var statusEl = document.getElementById('jv-hub-invite-status-' + idx);
    var retry = function () { handleSendInviteEmail(idx, btn); };
    btn.disabled = true;
    setStatus(statusEl, 'Sending...');
    // No manual timer needed: gasPost (jvHubFetch) guarantees a callback within 15s.
    gasPost('bridge_party_sendInviteEmail', {
      memberEmail: member.email,
      memberName:  member.name,
      memberRole:  member.role || 'Party Member',
      memberPhone: member.phone || ''
    }, function (data) {
      btn.disabled = false;
      if (!data || !data.ok) {
        setStatus(statusEl, (data && data.error) || "That invite didn't send. Please try again.", true, retry);
        return;
      }
      // DEDUP FIX (2026-09-11, Admin CRM E2E investigation, Issue 3a): bridge_party_sendInviteEmail
      // always returns {ok:true, deduped:...} even when the send was suppressed as a duplicate --
      // this function previously checked ONLY data.ok, so a dedup-suppressed attempt showed
      // "Invite sent" and flipped the status badge to pending even though nothing actually sent.
      // The backend already stopped the worse half (the badge flip permanently corrupting the
      // persisted status) by gating that metaobject write on !deduped; this closes the matching
      // frontend half so the bride is told the truth too.
      if (data.deduped) {
        setStatus(statusEl, 'An invite was already sent recently. Try again later.', true, retry);
        return;
      }
      setStatus(statusEl, 'Invite sent to ' + member.email);
      showToast('Invite sent to ' + member.name);
      var card = btn.closest('[data-member-index]');
      if (card) {
        var badge = card.querySelector('[data-status="not_sent"]');
        if (badge) {
          badge.setAttribute('data-status', 'pending');
          badge.className = badge.className.replace('jv-party-hub__badge--not-started', 'jv-party-hub__badge--pending');
          badge.textContent = badgeForStatus('pending').label;
        }
      }
    }, function () {
      btn.disabled = false;
      setStatus(statusEl, undefined, true, retry);
    });
  }

  // ── Add member form ──────────────────────────────────────────────────────
  function openAddForm() {
    if (!addForm) return;
    addForm.style.display = '';
    addForm.setAttribute('aria-hidden', 'false');
    if (addToggle) addToggle.setAttribute('aria-expanded', 'true');
    if (addName) addName.focus();
  }

  function closeAddForm() {
    if (!addForm) return;
    addForm.style.display = 'none';
    addForm.setAttribute('aria-hidden', 'true');
    if (addToggle) addToggle.setAttribute('aria-expanded', 'false');
    // Clear the live invite-email duplicate warning when the form is dismissed
    // or reset, so a stale collision message never lingers on next open.
    if (addEmailWarn) { addEmailWarn.textContent = ''; addEmailWarn.hidden = true; }
  }

  if (addToggle) {
    addToggle.addEventListener('click', function () {
      var isOpen = addToggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) closeAddForm(); else openAddForm();
    });
  }

  document.querySelectorAll('.js-party-hub-add-cancel').forEach(function (btn) {
    btn.addEventListener('click', closeAddForm);
  });

  if (addSubmit) {
    addSubmit.addEventListener('click', function doAddMember() {
      var name = addName ? addName.value.trim() : '';
      if (!name) { setStatus(addStatus, 'Please enter a name.', true); return; }
      var email = addEmail ? addEmail.value.trim() : '';
      // Invite-email duplicate guard (2026-07-18). A non-blank email that already
      // belongs to another loaded member (or the bride herself) is BLOCKED so two
      // distinct people can never silently merge under one email again. A BLANK
      // email is always allowed (the guided path for a member with no email of
      // their own). Pre-check is against the in-memory _members list, no GAS call.
      var emailOwner = _findEmailOwner(email, null);
      if (emailOwner) {
        _updateAddEmailWarn();
        setStatus(addStatus, 'This email already belongs to ' + emailOwner
          + '. Give this person their own email, or leave the email blank to add them without an invite.', true);
        if (addEmail && addEmail.focus) addEmail.focus();
        return;
      }
      var phone = addPhone ? addPhone.value.trim() : '';
      var role = addRole ? addRole.value : 'Bridesmaid';
      // Preserve every existing field when rebuilding the member list — otherwise
      // bridge_bride_updatePartyMembers writes a stripped-down metafield that
      // clobbers profile_pic_url, hair/makeup inspo, colour palette, etc.
      // (Same clobber pattern that hit the bride profile pic on Love Story save.)
      var updated = _members.map(function (m) {
        var copy = {};
        Object.keys(m).forEach(function (k) { copy[k] = m[k]; });
        return copy;
      });
      updated.push({ name: name, email: email, phone: phone, role: role });
      addSubmit.disabled = true;
      // Honest progress copy (2026-07-09): the add can take ~20-30s on a cold GAS
      // instance. Set an unalarming "this can take a moment" message up front so the
      // wait never reads as a stall, and a slow-but-successful add feels expected.
      setStatus(addStatus, 'Adding, this can take a moment...');
      // 2026-07-08: same fix family as doRename; updatePartyMembers does CRM +
      // metafield + metaobject multi-writes that exceed the 15s client abort on a
      // cold GAS instance, so use jvHubFetch at 45s (falling back to gasPost).
      // Finalise a clean add (all members saved, no failures). Shared by the
      // normal success path and the 503 false-failure recovery path.
      // (2026-07-08.)
      function finishAddClean(membersFromServer) {
        var freshByNameClean = {};
        (membersFromServer || []).forEach(function (m) {
          freshByNameClean[String(m.name || '').toLowerCase()] = m;
        });
        _members = updated.map(function (m) {
          var fresh = freshByNameClean[String(m.name || '').toLowerCase()];
          if (fresh) {
            if (fresh.email !== undefined) m.email = fresh.email;
            if (fresh.role  !== undefined) m.role  = fresh.role;
          }
          return m;
        });
        if (addName) addName.value = '';
        if (addEmail) addEmail.value = '';
        if (addPhone) addPhone.value = '';
        if (addRole) addRole.value = 'Bridesmaid';
        setStatus(addStatus, '');
        closeAddForm();
        updatePill(_members);
        if (grid) { grid.style.display = ''; renderGrid(_members); }
        if (empty) empty.style.display = 'none';
        showToast('Party member added');
      }
      // Silent recovery for the add path: on a non-OK/503/timeout response, re-fetch
      // and confirm the newly-added member (matched by name) actually landed. If it
      // did, treat as a clean success; otherwise show the real error.
      // 2026-07-09 Stage-2 safety net: a slow add can commit server-side a few
      // seconds AFTER the client aborts at 45s (verified in the grade-3 retest), so
      // a single immediate verify can miss it and show a false failure. RETRY the
      // verify a couple of times with backoff before declaring failure. The verify
      // is read-only and idempotent, so retrying is safe and cannot duplicate.
      function recoverAddOrFail(showError) {
        var attempts = [0, 2500, 6000]; // check now, then +2.5s, then +6s
        var idx = 0;
        function tryOnce() {
          verifyMemberSaved({ name: name, formData: {} }, function (ok, members) {
            if (ok) { addSubmit.disabled = false; finishAddClean(members); return; }
            idx++;
            if (idx < attempts.length) {
              // Still not visible, keep the honest progress copy, do not alarm yet.
              setStatus(addStatus, 'Still saving, this can take a moment...');
              setTimeout(tryOnce, attempts[idx]);
            } else {
              showError();
            }
          });
        }
        tryOnce();
      }
      var addMemberOk = function (data) {
        addSubmit.disabled = false;
        if (!data || !data.success) {
          if (data && data.failures && data.failures.length) {
            try { console.error('[bridal-hub] party-member save catastrophic failures:', data.failures); } catch (_) {}
          }
          recoverAddOrFail(function () {
            addSubmit.disabled = false;
            setStatus(addStatus, (data && (data.message || data.error)) || "That didn't save. Please try again.", true, doAddMember);
          });
          return;
        }
        // Phase 3 — partial-failure surfacing. Backend returns success=true if
        // at least one member saved, but lists per-member failures separately.
        var failures = (data && data.failures) || [];
        var failedNamesLc = {};
        failures.forEach(function (f) {
          if (f && f.name) failedNamesLc[String(f.name).toLowerCase()] = true;
        });
        // The backend response trims members down to {name, email, role, saved}.
        // Merging it directly into _members would clobber profilePicUrl + every
        // other field the cards rely on. Use the local `updated` array (which
        // preserves all existing fields) and only adopt the backend's trimmed
        // role/email if they differ. Drop members that failed to save — they
        // were never written to the canonical store.
        var freshByName = {};
        ((data && data.members) || []).forEach(function (m) {
          freshByName[String(m.name || '').toLowerCase()] = m;
        });
        _members = updated
          .filter(function (m) { return !failedNamesLc[String(m.name || '').toLowerCase()]; })
          .map(function (m) {
            var fresh = freshByName[String(m.name || '').toLowerCase()];
            if (fresh) {
              // Only the backend's trimmed fields can change in this code path.
              if (fresh.email !== undefined) m.email = fresh.email;
              if (fresh.role  !== undefined) m.role  = fresh.role;
            }
            return m;
          });
        if (failures.length) {
          var failedNames = failures.map(function (f) { return f.name; }).join(', ');
          setStatus(addStatus, 'Saved with errors. Could not save: ' + failedNames + '. Please try again or contact support.', true);
          try { console.error('[bridal-hub] party-member save failures:', failures); } catch (_) {}
          // Leave the form populated so the bride can retry the failed member
          // without re-typing. Keep the panel open.
          updatePill(_members);
          if (grid) { grid.style.display = ''; renderGrid(_members); }
          if (empty) empty.style.display = 'none';
          return;
        }
        if (addName) addName.value = '';
        if (addEmail) addEmail.value = '';
        if (addPhone) addPhone.value = '';
        if (addRole) addRole.value = 'Bridesmaid';
        setStatus(addStatus, '');
        closeAddForm();
        updatePill(_members);
        if (grid) { grid.style.display = ''; renderGrid(_members); }
        if (empty) empty.style.display = 'none';
        showToast('Party member added');
      };
      var addMemberErr = function () {
        // Network/503 failure. Re-verify before surfacing the error (the write
        // may have landed despite the 503 false-failure).
        recoverAddOrFail(function () {
          addSubmit.disabled = false;
          setStatus(addStatus, undefined, true, doAddMember);
        });
      };
      // D1 fast-path wiring (2026-09-30). window.jvHubPartyCrud.updatePartyMembers
      // (assets/jv-bridal-hub-resilience.js) is gated on
      // window.JV_HUB_PARTY_CRUD_FASTPATH.updatePartyMembers and defaults to
      // OFF -- with the flag unset this calls straight through to the exact
      // same window.jvHubFetch('bridge_bride_updatePartyMembers', ...) call
      // this replaced, byte-identical payload and timeout, so this change is
      // a no-op until the flag is armed for a live-verified test.
      //
      // SHAPE MISMATCH GUARD, read this before touching the callback below:
      // the adapter's onOk fires with EITHER the Worker's fast-path response
      // ({ok:true, writtenTo:'d1', ...}) OR, on any fallback/refusal, the
      // real GAS response ({success, members, failures}) forwarded verbatim
      // from its own internal toGas(). addMemberOk only understands the GAS
      // shape (checks data.success) -- passing a fast-path response straight
      // into it would read as a false failure even though the D1 write
      // genuinely landed. writtenTo:'d1' is the one field only the Worker's
      // success response ever sets, so it is what tells the two shapes apart
      // here. On a genuine D1 confirm we do NOT wait on GAS at all -- we
      // confirm from local state via finishAddClean(updated), the same
      // "durable write already happened, paint local state now" pattern
      // Build Doctrine 2 already uses everywhere else in this file.
      if (window.jvHubPartyCrud && window.jvHubPartyCrud.updatePartyMembers) {
        window.jvHubPartyCrud.updatePartyMembers(updated, {
          email: customerEmail, customerId: customerId,
          brideName: (window._jvHubBootstrapWidgets && window._jvHubBootstrapWidgets.brideName) || '',
          timeoutMs: 45000,
          onOk: function (d) {
            if (d && d.writtenTo === 'd1') { addSubmit.disabled = false; finishAddClean(updated); return; }
            addMemberOk(d);
          },
          onErr: addMemberErr
        });
      } else if (window.jvHubFetch) {
        window.jvHubFetch('bridge_bride_updatePartyMembers', { partyData: { members: updated } }, {
          email: customerEmail, customerId: customerId,
          timeoutMs: 45000,
          onOk: addMemberOk,
          onErr: addMemberErr
        });
      } else {
        gasPost('bridge_bride_updatePartyMembers', { partyData: { members: updated } }, addMemberOk, addMemberErr);
      }
    });
  }

  // ── Guest completion polling ─────────────────────────────────────────────
  // Polls every 30 s so the bride sees guest form completions within ~30 s.
  // Pauses when the tab is hidden; stops when all members are complete.
  var _pollTimer = null;
  var POLL_MS = 30000;
  var jvPollCount = 0;

  function statusSnapshot(members) {
    return members.map(function (m) { return m.name + ':' + (m.formStatus || 'not_sent'); }).join('|');
  }

  function allComplete(members) {
    return members.length > 0 && members.every(function (m) { return m.formStatus === 'completed'; });
  }

  function pollForUpdates() {
    jvPollCount += 1;
    if (jvPollCount >= 10) { stopPolling(); return; }
    if (document.hidden) return;
    getPartyMembers(function (data) {
      if (!data || !data.success) return;
      var fresh = data.members || [];
      if (statusSnapshot(fresh) === statusSnapshot(_members)) return;
      // Invalidate cache for members whose status just flipped to completed
      // (they submitted their own form — our cached data may be stale or empty)
      fresh.forEach(function (fm) {
        var wasComplete = false;
        for (var ci = 0; ci < _members.length; ci++) {
          if (_members[ci].name === fm.name) {
            wasComplete = (_members[ci].formStatus === 'completed');
            break;
          }
        }
        if (!wasComplete && fm.formStatus === 'completed') {
          delete _profileCache[fm.name];
          delete _inspoCache[fm.name];
        }
      });
      // Only act on members that transitioned to completed — update badges in-place
      // rather than re-rendering the whole grid (which causes cards to flash/disappear).
      var anyNewCompletions = false;
      fresh.forEach(function (fm) {
        for (var ci = 0; ci < _members.length; ci++) {
          if (_members[ci].name === fm.name && _members[ci].formStatus !== 'completed' && fm.formStatus === 'completed') {
            _members[ci].formStatus = 'completed';
            anyNewCompletions = true;
            // Update badge in-place without rebuilding the card
            var card = grid && grid.querySelector('.jv-party-hub__card[data-member-index="' + ci + '"]');
            if (card) {
              var badge = card.querySelector('[data-status]');
              if (badge) {
                badge.setAttribute('data-status', 'completed');
                badge.className = badge.className.replace(/jv-party-hub__badge--\S+/, 'jv-party-hub__badge--completed');
                badge.textContent = 'Profile Complete';
              }
            }
            delete _profileCache[fm.name];
            delete _inspoCache[fm.name];
          }
        }
      });
      if (anyNewCompletions) updatePill(_members);
      if (allComplete(_members)) stopPolling();
    }, function () { /* silent on poll error — try again next tick */ });
  }

  function startPolling() {
    if (_pollTimer) return;
    _pollTimer = setInterval(pollForUpdates, POLL_MS);
  }

  function stopPolling() {
    clearInterval(_pollTimer);
    _pollTimer = null;
  }

  // Resume an immediate check when the bride tabs back in
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && _pollTimer) pollForUpdates();
  });

  window.addEventListener('beforeunload', stopPolling);

  // ── Avatar click → trigger hidden file input ─────────────────────────────
  document.addEventListener('click', function (e) {
    var avatar = e.target.closest('.jv-party-hub__avatar--clickable');
    if (!avatar) return;
    var idx = parseInt(avatar.getAttribute('data-upload-idx'), 10);
    var input = document.querySelector('.jv-party-hub__pic-file-input[data-member-index="' + idx + '"]');
    if (input) input.click();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var avatar = e.target.closest('.jv-party-hub__avatar--clickable');
    if (!avatar) return;
    e.preventDefault();
    var idx = parseInt(avatar.getAttribute('data-upload-idx'), 10);
    var input = document.querySelector('.jv-party-hub__pic-file-input[data-member-index="' + idx + '"]');
    if (input) input.click();
  });

  // ── Profile photo upload (event delegation on document) ──────────────────
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList.contains('jv-party-hub__pic-file-input')) return;
    var file = input.files && input.files[0];
    if (!file) return;
    var idx = parseInt(input.getAttribute('data-member-index'), 10);
    var member = _members[idx];
    if (!member) return;
    var statusEl = document.getElementById('jv-hub-photo-status-' + idx);
    var avatarEl = document.querySelector('.jv-party-hub__avatar--clickable[data-upload-idx="' + idx + '"]');
    if (statusEl) statusEl.textContent = 'Uploading…';
    input.disabled = true;
    if (avatarEl) {
      avatarEl.style.pointerEvents = 'none';
      avatarEl.style.opacity = '0.55';
    }
    function _restoreProfilePicUploadUI() {
      input.disabled = false;
      input.value = '';
      if (avatarEl) {
        avatarEl.style.pointerEvents = '';
        avatarEl.style.opacity = '';
      }
    }

    var reader = new FileReader();
    reader.onload = function (ev) {
      var localPreview = ev.target.result; // data URL for immediate preview if Shopify URL not ready
      var b64 = localPreview.split(',')[1];
      function doPartyPicUpload() {
        if (statusEl) { statusEl.className = 'jv-party-hub__status-msg jv-hub-saving'; statusEl.textContent = 'Uploading…'; }
        input.disabled = true;
        if (avatarEl) { avatarEl.style.pointerEvents = 'none'; avatarEl.style.opacity = '0.55'; }
        gasPost('bridge_party_uploadProfilePic', {
          memberName: member.name,
          memberRole: member.role,
          fileName:   file.name,
          mimeType:   file.type,
          base64Data: b64
        }, function (res) {
          if (res && res.ok) {
            // Local preview (data: URL) renders fine as-is; remote URLs need the
            // Drive thumbnail rewrite or they 403 in incognito.
            var rawSrc = res.fileUrl || localPreview;
            var imgSrc = (rawSrc.indexOf('data:') === 0) ? rawSrc : JV_driveImg(rawSrc);
            if (avatarEl) {
              avatarEl.innerHTML = '<img class="jv-party-hub__avatar-img" src="' + imgSrc + '" alt="' + (member.name || '').replace(/"/g, '') + '" loading="lazy">';
            }
            if (statusEl) { statusEl.className = 'jv-party-hub__status-msg'; statusEl.textContent = ''; }
            _restoreProfilePicUploadUI();
          } else {
            _restoreProfilePicUploadUI();
            if (window.jvHubWarmError) window.jvHubWarmError(statusEl, doPartyPicUpload, { message: "That photo didn't upload. Please try again.", baseClass: 'jv-party-hub__status-msg' });
            else if (statusEl) statusEl.textContent = "That photo didn't upload. Please try again.";
          }
        }, function () {
          _restoreProfilePicUploadUI();
          if (window.jvHubWarmError) window.jvHubWarmError(statusEl, doPartyPicUpload, { baseClass: 'jv-party-hub__status-msg' });
          else if (statusEl) statusEl.textContent = "That photo didn't upload. Please try again.";
        }, JV_UPLOAD_TIMEOUT_MS);
      }
      doPartyPicUpload();
    };
    reader.readAsDataURL(file);
  });

  // ── Resend invite (blob-path cards — uses pm_id from jv_party_members_json) ─
  function wireResendInviteEvents() {
    if (!grid) return;
    grid.querySelectorAll('.js-party-hub-resend-invite').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pmId = btn.getAttribute('data-pm-id');
        var idx  = btn.getAttribute('data-member-index');
        handleResendInvite(pmId, idx, btn);
      });
    });
  }

  function handleResendInvite(pmId, idx, btn) {
    if (!pmId) return;
    var statusEl = document.getElementById('jv-hub-resend-status-' + idx);
    var retry = function () { handleResendInvite(pmId, idx, btn); };
    btn.disabled = true;
    setStatus(statusEl, 'Sending…');
    gasPost('bridge_party_resendInvite', { pm_id: pmId }, function (data) {
      btn.disabled = false;
      if (!data || !data.ok) {
        setStatus(statusEl, (data && data.error) || "That invite didn't send. Please try again.", true, retry);
        return;
      }
      setStatus(statusEl, 'Invite sent!');
      showToast('Invite resent to party member');
    }, function () {
      btn.disabled = false;
      setStatus(statusEl, undefined, true, retry);
    });
  }

  // ── Kick off initial load (DOM-parse if server-rendered, GAS fallback) ────
  var _metafieldSetup = boot.metafieldSetup;
  var _serverCards = grid ? grid.querySelectorAll('.jv-party-hub__card') : [];
  if (_serverCards.length > 0) {
    Array.prototype.forEach.call(_serverCards, function (card) {
      var nameEl  = card.querySelector('.jv-party-hub__card-name');
      var roleEl  = card.querySelector('.jv-party-hub__card-role');
      var badgeEl = card.querySelector('[data-status]');
      // Empty pre-seeded slot cards show "Add a name" as their visible name. Use
      // the card's data-pm-id + data-placeholder so _members carries the slot
      // identity (not the literal "Add a name" text), so the blob hydration below
      // can match by pm_id and the edit flow can fill the slot.
      var cardPmId       = card.getAttribute('data-pm-id') || '';
      var cardPlaceholder = card.getAttribute('data-placeholder') === '1';
      if (nameEl) {
        _members.push({
          name:       cardPlaceholder ? '' : nameEl.textContent.trim(),
          role:       roleEl  ? roleEl.textContent.trim()                     : '',
          formStatus: badgeEl ? (badgeEl.getAttribute('data-status') || 'not_sent') : 'not_sent',
          pm_id:      cardPmId,
          is_empty:   cardPlaceholder,
          slot_status: cardPlaceholder ? 'empty' : 'filled'
        });
      }
    });
    var _blobHydrated=false;
    try{var _bn=document.getElementById('jv-party-blob-data');if(_bn&&_bn.textContent){var _b=JSON.parse(_bn.textContent);if(_b&&_b.members&&_b.members.length){var _BK={pm_id:'pm_id',colour_palette:'colourPalette',hair_style:'hairStyle',skin_concerns:'skinConcerns',allergies:'allergies',inspo_notes:'inspoNotes',hair_notes:'hairNotes',profile_pic_url:'profilePicUrl',hair_inspo_urls:'hairInspoUrls',makeup_inspo_urls:'makeupInspoUrls',completed_at:'profileSubmittedAt',form_status:'formStatus',service:'service',artist:'artist',start_time:'start_time',service_duration:'service_duration',is_empty:'is_empty',slot_status:'slot_status',slot_label:'slot_label'};_b.members.forEach(function(bm){var n=String(bm.name||'').trim().toLowerCase();var bpid=String(bm.pm_id||'').trim();if(!n&&!bpid)return;for(var i=0;i<_members.length;i++){var mpid=String(_members[i].pm_id||'').trim();var matchByPid=bpid&&mpid&&mpid===bpid;var matchByName=n&&String(_members[i].name||'').trim().toLowerCase()===n;if(!matchByPid&&!matchByName)continue;Object.keys(_BK).forEach(function(s){var v=bm[s];if(v!==null&&v!==undefined&&v!=='')_members[i][_BK[s]]=v;});if(bm.profile_pic_url){var c=grid.querySelector('.jv-party-hub__card[data-member-index="'+i+'"]'),a=c&&c.querySelector('.jv-party-hub__avatar');if(a&&!a.querySelector('img')){var im=document.createElement('img');im.className='jv-party-hub__avatar-img';im.src=JV_driveImg(bm.profile_pic_url);im.alt=bm.name||'';im.loading='lazy';a.innerHTML='';a.appendChild(im);}}var _pu=function(csv,cat){return String(csv||'').split(',').map(function(u){return u.trim();}).filter(function(u){return !!u;}).map(function(u){var m=u.match(/lh3\.googleusercontent\.com\/d\/([A-Za-z0-9_-]+)/)||u.match(/drive\.google\.com\/file\/d\/([A-Za-z0-9_-]+)/)||u.match(/drive\.google\.com\/(?:uc|open|thumbnail)\?(?:[^#]*[?&])?id=([A-Za-z0-9_-]+)/);var fid=m?m[1]:'';return{url:u,thumbUrl:u,category:cat,name:'',fileId:fid};});};if(!_members[i].is_empty&&_members[i].name){var _bi=_pu(bm.hair_inspo_urls,'Hair').concat(_pu(bm.makeup_inspo_urls,'Makeup'));if(_inspoCache[_members[i].name]===undefined)_inspoCache[_members[i].name]=_bi;_profileCache[_members[i].name]={colourPalette:_members[i].colourPalette||'',hairStyle:_members[i].hairStyle||'',skinConcerns:_members[i].skinConcerns||'',allergies:_members[i].allergies||'',inspoNotes:_members[i].inspoNotes||'',submittedAt:_members[i].profileSubmittedAt||null};}break;}});_blobHydrated=true;}}}catch(e){}

    if (loading) loading.style.display = 'none';
    if (empty)   empty.style.display   = 'none';
    if (grid)    grid.style.display    = '';
    updatePill(_members);
    wireCardEvents();
    wireResendInviteEvents();

    if(!_blobHydrated){getPartyMembers(function(data){if(!data||!data.success||!data.members)return;var EK=['pm_id','email','profilePicUrl','colourPalette','hairStyle','skinConcerns','allergies','inspoNotes','hairInspoUrls','makeupInspoUrls','profileSubmittedAt','lastLogin','accessGranted'];data.members.forEach(function(gm){var n=String(gm.name||'').trim().toLowerCase();if(!n)return;for(var i=0;i<_members.length;i++){if(String(_members[i].name||'').trim().toLowerCase()===n){EK.forEach(function(k){if(gm[k]!==null&&gm[k]!==undefined&&gm[k]!=='')_members[i][k]=gm[k];});break;}}});Object.keys(_loadedCards).forEach(function(k){var idx=parseInt(k,10);if(_members[idx])loadTextDetails(idx,_members[idx]);});});}
  } else {
    // No server-rendered cards — always fall back to GAS for up-to-date member list.
    // The _metafieldSetup short-circuit was removed because custom.bridal_party can be
    // set without Liquid rendering cards (storefront access lag, CDN propagation, etc.).
    loadPartyMembers();
  }
  // Polling starts after initial render is settled
  setTimeout(startPolling, 2000);

  }); // end _JV_PREVIEW_READY.then
});
